<template>
  <div
    :style="isDialogue ? 'max-height: calc(100vh - 82px) !important; overflow: hidden; height: calc(100vh - 82px) !important;'
     : 'max-height: calc(100vh - 82px) !important; overflow: hidden; height: calc(100vh - 82px) !important;'"
  >
    <v-card class="docComparisonHolder" >
      <v-card-text>
        <v-row dense class="docComparisonFilterRowExpanded">
          <v-col cols="2">
            <v-select
              dense
              label="Full View Part List"
              multiple
              :items="fullDocParts"
              v-model="fullViewPartList"
              item-text="type"
              item-value="tmpl_part_id"
              @change="toggleFullViewPart"
              outlined
              class="essentialFlag"
            >
            <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @mousedown.prevent
                  @click="toggleAllViewParts"
                >
                  <v-list-item-action>
                    <v-icon :color="fullViewPartList.length > 0 ? 'indigo darken-4' : ''">
                      {{fullViewPartIcon}}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>            
              <template v-slot:selection="{ item, index }">
                {{ getPartFilterText(item, index) }}
              </template>
            </v-select>
          </v-col>
          <v-col align="right">
            <span style="padding-right: 80px">
              <v-btn
                icon
                color="green"
                style="margin-right: 15px"
                @click="showSuggestionsPanel"
              >
                <v-icon color="green">mdi-format-list-checkbox</v-icon>
              </v-btn>
              <v-btn icon @click="showDatabasePanel" style="margin-right: 15px">
                <v-icon title="View Database">mdi-database-cog</v-icon>
              </v-btn>
              <v-btn icon style="margin-right: 15px; display: none">
                <v-icon title="Upload">mdi-cloud-upload</v-icon>
              </v-btn>
            </span>
            <v-btn
              v-if="!isDialogue"
              icon
              small
              @click="changeView('cards')"
              title="Card View"
              class="ml-3"
            >
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
            <v-btn
              v-if="!isDialogue"
              icon
              small
              @click="changeView('table')"
              title="Table View"
              class="ml-3"
            >
              <v-icon>mdi-view-list</v-icon>
            </v-btn>
            <v-icon v-if="isDialogue" @click="close" class="float-right pt-3"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
        <v-row class="docComparisonContentExpanded">
          <v-col cols="12" style="display: flex;
                max-height: calc(100vh - 135px);
                overflow-x: scroll;">
            <!-- <div
              style="
                display: -webkit-inline-box;
                flex-direction: row;
                width: 100%;
                padding-left: 15px;
                margin-top: 0px;
              "
              v-if="pinnedDoc"
            >
              <div
                class="pinnedCardFull compareCardFull"
                @dragover.prevent
                @mouseover="pinnedDoc.hover = true;" @mouseout="pinnedDoc.hover = false;"
              >
              <div class="handle" style="padding: 0px 15px">
                  <div style="display: inline-flex; width: 100%">
                    <div
                      align="left"
                      v-html="pinnedDoc.system_number"
                      style="width: 25%; font-size: 11px"
                    ></div>
                    <div
                      class="docLinks"
                      align="center"
                      style="display: flex; margin-left: 8px; padding-top: 2px"
                    >
                      <v-progress-circular
                        style="cursor: pointer"
                        @mousedown.stop
                        @click.stop="openSummaryMenu(pinnedDoc.doc_id, $event)"
                        :rotate="90"
                        :size="30"
                        :width="3"
                        :value="pinnedDoc.checkSummary.score"
                        :color="pinnedDoc.checkSummary.scoreColour"
                      >
                        <span style="font-size: 11px">{{
                          pinnedDoc.checkSummary.score
                        }}</span>
                      </v-progress-circular>
                      <DocStatus
                        :document="pinnedDoc"
                        xSmall
                        style="margin-top: 7px; margin-left: 7px"
                      ></DocStatus>
                    </div>
                    <div align="right" style="width: 50%; padding-right: 5px">
                      <v-icon
                              class="compareIcons"
                              :title="pinnedDoc.commentsVisible ? 'Hide Comments' : 'Show Comments'"
                              @click="showComments(pinnedDoc, !pinnedDoc.commentsVisible)"
                              >mdi-message-outline</v-icon
                            >
                            <v-icon
                          :class="{ disabledIcon: pinnedDoc.lockedByPermission }"
                          :color="pinnedDoc.locked ? '#ff8137' : ''"
                          @click="pinnedDoc.locked = !pinnedDoc.locked"
                          :title="
                            pinnedDoc.lockedByPermission
                              ? 'Cannot Edit - No Permission'
                              : pinnedDoc.locked
                              ? 'Make Editable'
                              : 'Lock From Editing'
                          "
                        class="compareIcons"
                      >
                        {{
                          pinnedDoc.locked || pinnedDoc.lockedByPermission
                            ? "mdi-lock-open"
                            : "mdi-lock"
                        }}</v-icon
                      >
                      <v-icon class="compareIcons"></v-icon>
                      <v-icon
                        color="#377DFF"
                        class="compareIcons"
                        @click="unPinItem(pinnedDoc)"
                        :title="pinnedDoc.pinned ? 'Unpin' : 'Pin'"
                      >
                        {{
                          pinnedDoc.pinned ? "mdi-pin-off" : "mdi-pin"
                        }}</v-icon
                      ><v-icon
                        class="compareIcons"
                        @click.stop="openContext($event, pinnedDoc)"
                        >mdi-dots-vertical</v-icon
                      >
                    </div>
                  </div>
                </div>
                <DocumentHolder 
                  :displayMethod="'sidebysidefull'"
                  :data="pinnedDoc.current_doc_view"
                  :readOnly="false"
                  :paddingOffset="'170px'"
                  :ref="`holder_${pinnedDoc.doc_id}`"
                  :commentsVisible="pinnedDoc.commentsVisible"
                  @triggerNotification="(text, type) => triggerNotification(pinnedDoc,text,type)"
                  @syncPositions="syncPositions"
                  :dataDrag="dragging && pinnedDoc.hover"
                  @checkSummaryUpdated="(summary) => checkSummaryUpdated(pinnedDoc,summary)"
                  @openSuggestions="openSuggestions"
                  @suggestionDropEnd="clearSuggestions"
                  @showComments="(visible) => showComments(pinnedDoc, visible)"
                ></DocumentHolder>
            
              </div>
            </div> -->
            <div
              style="
                display: -webkit-inline-box;
                flex-direction: row;
                width: 100%;
                padding-left: 15px;
                margin-top: 0px;
              "
              v-if="!compareLoading"
                  ref="activeDocs"
            >
                <template
                  v-for="(j, di) in activeDocs"
                >
                  <div
                    :key="j.doc_id"
                    @mouseover="j.hover = true;" 
                    @mouseout="j.hover = false;">
                    <div
                      class="move-handle" :style="!j.hover || j.pinned ? 'visibility: hidden;' : null">
                       <!-- :style="!j.hover ? 'visibility: hidden;' : null" -->
                      <v-icon class="ml-2" @click="reOrder(di, di - 1)" :disabled="di === 0" title="Move document to the left">mdi-chevron-left</v-icon>
                      <v-icon class="ml-2" @click="removeDocument(di)" small title="Remove document from the list">mdi-sticker-remove-outline</v-icon>
                      <v-icon class="mx-2 drag-handle" title="Drag to reorder"
                        draggable="true"
                        @dragstart="handleDragStart($event, di, j)"
                        @dragend="handleDragEnd"
                        @dragover.prevent="handleDragOver($event, di, j)"
                        @dragleave="handleDragLeave"
                        @drop.prevent="handleDrop(di, j)"
                      >mdi-drag</v-icon>
                      <v-icon class="mr-2" @click="reOrder(di, di + 1)" :disabled="di + 1 === activeDocs.length" title="Move document to the right">mdi-chevron-right</v-icon>
                    </div>
                    <div
                      class="compareCardFull" :style="j.docContainerStyle"
                      >
                      <!-- @drop="dropItem(j.doc_id, $event)" -->
                      <div style="padding: 0px 10px">
                        <div class="header-handle" style="display: inline-flex;" :style="j.docHeaderStyle"
                          :draggable="!j.pinned"
                          @dragstart="handleDragStart($event, di, j)"
                          @dragend="handleDragEnd"
                          @dragover.prevent="handleDragOver($event, di, j)"
                          @dragleave="handleDragLeave"
                          @drop.prevent="handleDrop(di, j)">
                          <!-- <div align="left" style="width: 10%; margin-top: -8px">
                            <v-checkbox
                              dense
                              v-if="isMultiPart"
                              @click="toggleAllParts(j)"
                              :indeterminate="j.indeterminate"
                              v-model="j.allSelected"
                              class="comparePartCheckBox"
                            ></v-checkbox>
                          </div> -->
                          <div
                            align="left"
                            v-html="j.system_number"
                            style="width: 25%; font-size: 11px"
                          ></div>
                          <div
                            class="docLinks"
                            align="center"
                            style="
                              display: flex;
                              margin-left: 8px;
                              padding-top: 2px;
                              cursor: pointer;
                            "
                          >
                            <v-progress-circular
                              style="cursor: pointer"
                              @mousedown.stop
                              @click.stop="openSummaryMenu(j.doc_id, $event)"
                              :rotate="90"
                              :size="30"
                              :width="3"
                              :value="j.checkSummary.score"
                              :color="j.checkSummary.scoreColour"
                            >
                              <span style="font-size: 11px">{{
                                j.checkSummary.score
                              }}</span>
                            </v-progress-circular>
                            <DocStatus
                              :document="j"
                              xSmall
                              style="margin-top: 7px; margin-left: 7px"
                            ></DocStatus>
                          </div>
                          <div align="right" style="width: 50%; padding-right: 0px">
                            <v-icon v-if="showAllComments"
                              class="compareIcons"
                              :title="j.commentsVisible ? 'Hide Comments' : 'Show Comments'"
                              @click="showComments(j, !j.commentsVisible)"
                              >mdi-message-outline</v-icon
                            >
                            <v-icon
                              class="compareIcons"
                              :class="{ disabledIcon: j.lockedByPermission }"
                              :color="j.locked ? '#ff8137' : ''"
                              @click="j.locked = !j.locked"
                              :title="
                                j.lockedByPermission
                                  ? 'Cannot Edit - No Permission'
                                  : j.locked
                                  ? 'Make Editable'
                                  : 'Lock From Editing'
                              "
                              >{{
                                j.locked || j.lockedByPermission
                                  ? "mdi-lock-open"
                                  : "mdi-lock"
                              }}</v-icon
                            >
                            <v-icon v-if="!j.pinned"
                              class="compareIcons"
                              title="Hide Document"
                              @click="j.visible = !j.visible"
                              >mdi-eye-off</v-icon
                            >
                            <v-icon
                              class="compareIcons"
                              @click="pinItem(j)"
                              :title="j.pinned ? 'Unpin' : 'Pin'"
                            >
                              {{ j.pinned ? "mdi-pin-off" : "mdi-pin" }}</v-icon
                            >
                            <v-icon
                              class="compareIcons"
                              @click.stop="openContext($event, j)"
                              >mdi-dots-vertical</v-icon
                            >
                          </div>
                     
                        </div>
                        <div v-if="j.commentsVisible" :style="j.commentStyle" style="display: inline-flex;">
                          <v-icon
                              class="compareIcons"
                              :title="j.commentsVisible ? 'Hide Comments' : 'Show Comments'"
                              @click="showComments(j, !j.commentsVisible)"
                              >mdi-chevron-left</v-icon
                            >
                        </div>
                        <DocumentHolder 
                          :displayMethod="'sidebysidefull'"
                          :data="j.current_doc_view"
                          :readOnly="false"
                          :paddingOffset="'170px'"
                          :ref="`holder_${j.doc_id}`"
                          :commentsVisible="j.commentsVisible"
                          @triggerNotification="(text, type) => triggerNotification(j,text,type)"
                          @syncPositions="syncPositions"
                          :dataDrag="dragging"
                          @checkSummaryUpdated="(summary) => checkSummaryUpdated(j,summary)"
                          @openSuggestions="openSuggestions"
                          @suggestionDropEnd="clearSuggestions"
                          @showComments="(visible) => showComments(j, visible)"
                        ></DocumentHolder>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="di === 0"
                    :key="'resize_' + j.doc_id"
                    class="resize-handle"
                    @mousedown.left="startResize($event)"
                  >
                    <div class="resize-handle-inner"></div>
                  </div>
                  <div
                    v-else-if="di > 0"
                    :key="'resize_' + j.doc_id"
                    class="resize-filler"
                  >
                  </div>
                </template>
            </div>
            <div
              style="
                display: -webkit-inline-box;
                overflow-x: scroll;
                max-width: 400px;
                flex-direction: row;
                width: 400px;
                min-width: 400px;
                padding-left: 5px;
                max-height: calc(100% - 25px);
                height: calc(100% - 25px);
                margin-top: 0px;
                overflow-x: hidden;
              "
              v-if="showSuggestions"
            >
              <div style="width: 345px; max-width: 345px">
                <div justify-center style="width: 100%" class="text-center doc-view-font small"> Suggestions - {{ targetPartDetails?.type }} </div>
                <SuggestionsPanel
                  ref="suggestionsPanel"
                  :part="suggestionsPart"
                  @close="closeSuggestions"
                  :docList="docTitleList"
                  @dragEnd="dragEnd"
                  @dragStart="initDrag"
                  @selectionUpdated="updateSuggestionSelection"
                ></SuggestionsPanel>
              </div>
            </div>
            <div
              style="
                display: -webkit-inline-box;
                overflow-x: scroll;
                max-width: 700px;
                flex-direction: row;
                width: 700px;
                min-width: 700px;
                padding-left: 5px;
                max-height: calc(100% - 25px);
                height: calc(100% - 25px);
                margin-top: 0px;
                overflow-x: hidden;
              "
              v-if="showDatabase"
            >
              <div style="width: 645px; max-width: 645px">
                <ContentDatabase
                  :isNew="false"
                  :multidoc="true"
                  @dragEnd="dragEnd"
                  @closeDatabasePanel="closeDatabase"
                  @dragStart="initDrag"
                  @selectionUpdated="updateDatabaseSelection"
                  @openDocument="openDocument"
                ></ContentDatabase>
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- <v-navigation-drawer
          v-model="docPartFilter"
          absolute
          fixed
          temporary
          clipped
          style="width: 350px; z-index: 1; padding: 5px" :class="isDialogue ? 'dialogue-nav-draw' : ''"
        >
          <v-toolbar-title class="d-flex align-center pl-1 pt-5">
            <span class="ml-2">Filter By Doc Part</span>
          </v-toolbar-title>
          <v-select
            dense
            label="Document Parts"
            outlined
            :items="allParts"
            v-model="targetPart"
            @change="loadParts"
            class="pt-5"
          ></v-select>
        </v-navigation-drawer> -->
        <!-- <v-navigation-drawer
          v-model="compareFilter"
          absolute
          fixed
          temporary
          clipped
          style="width: 350px; z-index: 1; padding: 5px" :class="isDialogue ? 'dialogue-nav-draw' : ''"
        >
          <v-row dense class="pl-2 pt-5">
            <v-col cols="12">
              <span>Compare Document Parts</span>
            </v-col>
            <v-col cols="4" align="center">
              <v-select
                dense
                outlined
                :items="diffModes"
                item-text="text"
                item-value="value"
                v-model="diffType"
              ></v-select>
            </v-col>
            <v-col cols="4" align="right">
              <v-btn style="margin-top: 9px" small @click="compareTest"
                >Compare</v-btn
              >
            </v-col>
            <v-col cols="4" align="left">
              <span dense style="display: inline-flex; padding-top: 5px">
                <v-btn plain color="primary" @click="clearCompare">
                  <v-icon style="padding-right: 5px">mdi-close</v-icon> Clear
                </v-btn>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="enableDocCompare" dense class="pl-2">
            <v-col cols="12">
              Compare Documents
              <v-chip class="ma-2" color="purple" label x-small>
                <span style="font-size: 10px; color: white">Beta</span>
              </v-chip>
            </v-col>
          </v-row>
        </v-navigation-drawer> -->
        <!-- <v-navigation-drawer
          v-model="viewFilter"
          absolute
          fixed
          temporary
          clipped
          style="width: 350px; z-index: 1; padding: 5px" :class="isDialogue ? 'dialogue-nav-draw' : ''"
        >
          <v-row dense class="pl-2 pt-5">
            <v-col cols="12" class="error--text">
              <b style="font-weight: bolder">Document List:</b>
            </v-col>
          </v-row>
          <v-row
            dense
            class="pl-2 pt-5"
            v-for="(doc, indx) in docDisplayItems"
            :key="indx"
          >
            <v-col dense cols="8">
              {{ doc.system_number }}
            </v-col>
            <v-col dense cols="4" align="right">
              <div style="width: 100%; display: flex">
                <div style="width: 25px; cursor: pointer" align="left">
                  <v-icon
                    @click="removeView('unlock', doc)"
                    title="Unlock Document"
                    dense
                    color="#ff8137"
                    v-if="doc.locked"
                    >mdi-lock</v-icon
                  >
                </div>
                <div style="width: 25px; cursor: pointer" align="center">
                  <v-icon
                    @click="removeView('view', doc)"
                    title="Restore View"
                    dense
                    color="green"
                    v-if="!doc.visible"
                    >mdi-eye-off</v-icon
                  >
                </div>
                <div style="width: 25px; cursor: not-allowed" align="right">
                  <v-icon
                    color="red"
                    title="Permissions locked"
                    v-if="doc.lockedByPermission"
                    dense
                    >mdi-cancel</v-icon
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-navigation-drawer> -->
        <!-- <v-navigation-drawer
          v-model="deleteFilters"
          absolute
          fixed
          temporary
          clipped
          style="width: 350px; z-index: 1; padding: 5px" :class="isDialogue ? 'dialogue-nav-draw' : ''"
        >
          <v-row dense class="pl-2 pt-5">
            <v-col cols="12"> </v-col>
          </v-row>
        </v-navigation-drawer> -->
        <!-- <v-navigation-drawer
          v-model="historyFilter"
          absolute
          fixed
          temporary
          clipped
          height="95vh"
          style="width: 450px; z-index: 1; padding: 5px; height: 95% !important" :class="isDialogue ? 'dialogue-nav-draw' : ''"
        >
          <div>
            <v-row
              dense
              class="pl-2 pt-5"
              v-for="(history, indx) in historyItems"
              :key="indx"
            >
              <v-col cols="6" class="pt-2">
                {{ history.item.doc_part_type }}<br />{{ history.type }}
              </v-col>
              <v-col cols="4" class="pt-2">
                {{ history.doc.system_number }}
              </v-col>
              <v-col cols="2" class="pt-2">
                <v-icon @click="revertChange(history)">mdi-undo</v-icon>
              </v-col>
              <v-col v-if="history.type === 'Add'" cols="12" class="pt-2">
                <span v-html="history.item.text"></span>
              </v-col>
              <v-col v-if="history.type === 'Update'" cols="12" class="pt-2">
                <span v-html="history.diff.content"></span>
              </v-col>
            </v-row>
          </div>
        </v-navigation-drawer> -->
      </v-card-text>
    </v-card>
    <!-- <v-dialog v-model="deleteConfirmDialog.show" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          {{ deleteConfirmDialog.message }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteConfirmDialog.show = false"> Cancel </v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- <v-dialog v-model="historyUndoDialog.show" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          {{ historyUndoDialog.message }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="historyUndoDialog.show = false"> Cancel </v-btn>
          <v-btn color="red darken-1" text @click="confirmUndo"> Undo </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- <v-dialog v-model="consolidateDialog.show" persistent max-width="1200">
      <v-card>
        <v-card-title class="text-h5">
          Create Consolidated Document:
        </v-card-title>
        <v-card-text>
          Are you sure you want to create a Consolidated Document ({{ consolidateDialog.data.docType }}) with the following details?<br/><br/>
          <v-row dense>
            <v-col cols="4"><b>Job Title:</b></v-col>
            <v-col cols="8">{{ consolidateDialog.data.doc_name }}</v-col>
          </v-row>
          <v-row dense  v-for="h in consolidateDialog.data.hierarchies" :key="h.ht_id">
            <v-col cols="4"><b>{{ h.ht_name }} Hierarchy:</b></v-col>
            <v-col cols="8">{{ h.hierarchy_text }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="consolidateDialog.show = false"> Cancel </v-btn>
          <v-btn color="green darken-1" text @click="createConsolidated"> Create Consolidated Document </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-overlay :value="compareLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-menu
      v-model="summaryMenu.show"
      :close-on-content-click="false"
      :close-on-click="false"
      offset-y
      offset-x
      :position-x="summaryMenu.x"
      :position-y="summaryMenu.y"
    >
      <v-card width="300px" height="420px" class="rm-context-menu">
        <v-card-title>
          Score Summary
          <v-spacer></v-spacer>
          <v-icon @click="summaryMenu.show = false" small right
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-left: 10px">
          <v-btn-toggle
            v-model="summaryMenu.display"
            tile
            color="deep-purple accent-3"
            group
          >
            <v-btn small value="category"> Categories </v-btn>
            <v-btn small value="part"> Parts </v-btn>
            <v-btn
              small
              value="detail"
              v-if="
                summaryMenu.partSummary !== null &&
                summaryMenu.partSummary.some((x) => x.type === this.targetPart)
              "
              @click="filterPartDetail"
            >
              Detail
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
        <v-card-text
          style="
            height: 330px;
            overflow: hidden;
            padding-top: 10px;
            padding-right: 5px;
          "
          scrollable
          v-if="summaryMenu.summaryMenuModel !== null"
        >
          <div
            style="height: 310px; overflow: hidden scroll; max-height: 310px"
          >
            <div v-if="summaryMenu.display === 'category'">
              <v-row dense>
                <v-col cols="10">Overall Score:</v-col>
                <v-col cols="2" align="right">{{
                  summaryMenu.summaryMenuModel.score
                }}</v-col>
              </v-row>
              <v-row
                dense
                v-for="(category, cIdx) in summaryMenu.summaryMenuModel
                  .categories"
                :key="cIdx"
              >
                <v-col cols="10">{{ category.category }}</v-col>
                <v-col cols="2" align="right">{{ category.score }}</v-col>
              </v-row>
            </div>
            <div v-if="summaryMenu.display === 'part'">
              <v-row
                dense
                v-for="(type, cIdx) in summaryMenu.partSummary"
                :key="cIdx"
              >
                <v-col cols="8">{{ type.type }}</v-col>
                <v-col cols="2">{{ type.count }}</v-col>
                <v-col cols="2" align="right">
                  <v-icon
                    v-if="type.type !== targetPart"
                    @click="setTargetPart(type.type)"
                    small
                    >mdi-text-box-search</v-icon
                  >
                </v-col>
              </v-row>
            </div>
            <div v-if="summaryMenu.display === 'detail'">
              Scoring Issues:<br />
              <v-row
                dense
                v-for="(issue, idx) in summaryMenu.partBreakdown.issues"
                :key="idx"
              >
                <v-col cols="8">{{ issue.issue }}</v-col>
                <v-col cols="4">{{ issue.count }}</v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
    <!-- <v-menu
      bottom
      left
      attach
      v-model="externalContentMenu.show"
      :value="externalContentMenu.show"
      :close-on-content-click="false"
      :nudge-width="200"
      :top="externalContentMenu.lookupTop"
      :position-y="externalContentMenu.lookupPosY"
      :position-x="externalContentMenu.lookupPosX"
      :max-width="externalContentMenu.lookupWidth"
      :min-width="externalContentMenu.lookupWidth"
      max-height="300px"
      height="300px"
      offset-x
      content-class="elevation-2 userPilotSuggestionsMenu"
    >
      <AIMenu :data="aiMenuData" @setValue="setValue"></AIMenu>
    </v-menu> -->
  </div>
</template>

<script>
// import draggable from "vuedraggable";
import axios from "axios";
import moment from "moment";
import utils from "@/common/utils.js";
// import LanguageMenu from "@/components/common/LanguageMenu";
// import TextInput from "@/components/common/TextInput";
// import LookupInput from "@/components/common/LookupInput";
import SuggestionsPanel from "@/components/common/SuggestionsPanel";
import nlpUtils from "@/common/nlpUtils.js";
import { mapState } from "vuex";
// import AIMenu from "@/components/document/view/AI_Function_Menu.vue";
import DocStatus from "@/components/common/DocStatus";
import DocumentHolder from "@/components/document/Document_Holder.vue";

import ContentDatabase from "@/components/common/ContentDatabase";
import {scroller} from 'vue-scrollto/src/scrollTo'
//import HierarchySearch from "@/components/cHierarchySearch";
var JsDiff = require("diff");

export default {
  name: "DocSideBySide",
  components: {
    // LanguageMenu,
    // TextInput,
    SuggestionsPanel,
    // LookupInput,
    // AIMenu,
    ContentDatabase,
    DocStatus,
    DocumentHolder,
    // draggable, //,HierarchySearch
  },
  props: {
    items: Array,
    isDialogue: Boolean,
  },
  data: function () {
    return {
      showSuggestions: false,
      showDatabase: false,
      docCompareItems: [],
      targetPart: "Responsibility",
      targetPartDetails: {},
      allParts: [],
      pinnedItem: null,
      diffModes: [
        { text: "Chars", value: "diffChars" },
        { text: "Words", value: "diffWords" },
      ],
      diffType: "diffWords",
      compareLoading: false,
      expandHover: false,
      drawer: true,
      // docPartFilter: false,
      // compareFilter: false,
      // viewFilter: false,
      // deleteFilters: false,
      selectedActiveParts: [],
      enableDocCompare: false,
      // deleteConfirmDialog: {
      //   message: "",
      //   show: false,
      //   data: [],
      // },
      updateDialog: {
        message: "",
        type: "data",
        show: false,
        data: [],
      },
      // historyUndoDialog: {
      //   message: "",
      //   show: false,
      //   data: [],
      // },
      // consolidateDialog: {
      //   message: "",
      //   show: false,
      //   data: [],
      // },
      historySelectAll: false,
      // historyFilter: false,
      historyItems: [],
      allCompareData: [],
      allChecksData: [],
      isComparing: false,
      summaryMenu: {
        show: false,
        x: 0,
        y: 0,
        summaryDoc: null,
        summaryMenuModel: null,
        partSummary: null,
        display: "category",
      },
      // essentialFlags: [
      //   {
      //     value: true,
      //     text: "Essential",
      //   },
      //   {
      //     value: false,
      //     text: "Non Essential",
      //   },
      // ],
      // languageMenu: {
      //   show: false,
      //   x: 0,
      //   y: 0,
      //   textStatus: null,
      //   element: null,
      //   match: null,
      // },
      dragging: false,
      suggestedItems: [],
      currentDragTarget: null,
      // useInlineEditor: true,
      // useSpellCheck: false,
      // externalContentMenu: {
      //   show: false,
      //   activeNode: false,
      //   loading: false,
      //   suggestionType: null,
      //   lookupMaxHeight: 300,
      //   lookupWidth: 500,
      //   lookupTop: false,
      //   lookupPosY: 0,
      //   lookupPosX: 0,
      //   lookupsToShow: 20,
      //   lookupsPageSize: 20,
      //   lookupData: [],
      // },
      aiMenuData: null,
      contentDatabaseData: null,
      // hiddenDocsMenu: false,
      // lockedDocsMenu: false,
      // consolidationActions: [],
      consolidateAction: null,
      fullDocParts: [],
      fullViewPartList: [],
      resizing: false,
      resizeStartX: 0,
      resizeStartWidth: 0,
      draggedIndex: null,
      dragOverIndex: null,
      viewSetting: { defaultColumnWidth: 600 },
    };
  },
  watch: {
    items(val) {
      this.docCompareItems = val;
      this.initCompare();
    },
  },
  mounted() {
    if (this.items.length) {
      this.docCompareItems = this.items;
      this.initCompare();
    }
  },
  beforeDestroy() {    
    const container = this.$refs.activeDocs;
    if (container) {
      container.removeEventListener('mousemove', this.handleResize);
      container.removeEventListener('mouseup', this.stopResize);
    }
  },
  computed: {
    selectedAllParts () {
      return this.fullDocParts.length === this.fullViewPartList.length
    },
    selectedSomeParts () {
      return this.fullViewPartList.length > 0 && !this.selectedAllParts
    },    
    fullViewPartIcon () {
        if (this.selectedAllParts) return 'mdi-close-box'
        if (this.selectedSomeParts) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },    
    docTitleList() {
      return this.activeDocs.map((x) => {
        return {
          doc_name: x.doc_name,
          doc_id: x.doc_id,
        };
      });
    },
    suggestionsPart() {
      if (this.targetPartDetails) {
        return {
          type: this.targetPartDetails.type,
          tmpl_part_id: this.targetPartDetails.tmpl_part_id,
          multiple:
            this.targetPartDetails.multi_row ||
            this.targetPartDetails.tmpl_part_metadata?.multi_row,
        };
      } else {
        return null;
      }
    },
    allHistorySelected() {
      let selected = this.historyItems.filter((x) => x.selected);
      return (
        selected.length > 0 &&
        selected.length < this.historyItems.length &&
        selected.length !== this.historyItems.length
      );
    },
    docDisplayItems() {
      return this.docCompareItems
        .filter(
          (x) =>
            x.visible === false ||
            x.lockedByPermission === true ||
            x.locked === true
        )
        .map((x) => {
          return {
            doc_id: x.doc_id,
            system_number: x.system_number,
            visible: x.visible,
            locked: x.locked,
            lockedByPermission: x.lockedByPermission,
          };
        });
    },
    validDocumentRange() {
      return this.docCompareItems.filter(
        (x) =>
          !x.pinned &&
          x.visible === true &&
          x.lockedByPermission === false &&
          x.locked === false
      );
    },
    editableDocs() {
      return this.docCompareItems.filter(
        (x) => !x.locked && !x.lockedByPermission && x.visible
      );
    },
    activeDocs() {
      let list = this.docCompareItems.filter(
        (x) => x.visible === true // && !x.pinned
      ).sort((a,b) => a.pinned ? -1 : b.pinned ? 1 : 0);
      return list;
    },
    lockedDocs() {
      let list = this.docCompareItems.filter((x) => x.locked === true);
      return list;
    },
    // isMultiPart() {
    //   if(this.compareLoading) return;
    //   return this.targetPartDetails.tmpl_part_metadata.multi_row;
    // },
    ...mapState({
      config: (state) => state.settings.config,
      statuses: (state) => state.hierarchies.statuses,
    }),
    // pinnedDoc() {
    //   return this.docCompareItems?.find((x) => x.pinned) ?? null;
    // },
    allowSummarise() {
      return this.config.contentGenerationConfig?.enableSummarise || false;
    },
    useOpenAISuggestions() {
      return this.config.contentGenerationConfig?.enablePartSuggestions;
    },
    allowConsolidation(){
      return this.$loginState.user.settings.some(
        (x) => x.setting === "alljobs_allow_doc_consolidate" && x.value === "true"
      )
    },
    dbDragRules() {
      return this.config.settings?.find((s) => s.setting === "database_drag_splitRules")?.value;
    },
    showAllComments(){
      return this.config.settings.some(
          (s) => s.setting === 'document_show_all_comments' && s.value === "true"
      );
    },   
  },
  methods: {
    openSuggestions(type){
      if(this.showSuggestions && this.targetPartDetails?.type !== type){
        this.targetPartDetails = this.fullDocParts.find(x => x.type === type.type);
      }
    },
    checkSummaryUpdated(doc, checkSummary) {
      doc.checkSummary = checkSummary;
      this.$store.dispatch("docs/updateDoc", doc);
    },
    syncPositions(item){
      this.docCompareItems.forEach(d => {
        let options = {
            container: "#docHolderCenter_ss_" + d.doc_id,
            easing: "ease-in",
            offset: -20,
            force: true,
            cancelable: true,
            x: false,
            y: true,
        };     
        let tmpScroller1 = scroller();
        tmpScroller1(`#viewcontainer_${d.doc_id}_${item.replace(/\s+/g, '').replace(/'+/g, '')}`, 500, options);
      })

    },
    toggleAllViewParts () {
        if (this.selectedAllParts) {
          this.fullViewPartList = [];
        } else {
          this.fullViewPartList = this.fullDocParts.map(x => { return x.tmpl_part_id});
        }
        this.toggleFullViewPart();
    },    
    getPartFilterText(item, index) {
      if (item && index > 0) return "";
      let included = this.fullDocParts.filter((s) =>
        this.fullViewPartList.some((si) => s.tmpl_part_id === si)
      );
      if (included.length === this.fullDocParts.length)
        return included.length > 0 ? "All" : "None";

      if (included.length > 2) return `${included.length} items`;

      return included.reduce((prev, curr) => {
        return prev + (prev ? ", " : "") + curr.type;
      }, "");
    },
    triggerNotification(doc, text, type){
      this.$emit("triggerNotification", `${doc.system_number}: ${text}`, type);    
    },
    toggleFullViewPart(){
      this.docCompareItems.forEach(d => {
        d.doc_view_config.sections[0].part_data.forEach(p => {
          p.permissions_list.viewPermissionOverride = this.fullViewPartList.includes(p.tmpl_part_id) ? null : false;
        });
        let status = this.statuses.find(
          (x) => x.status === d.doc_status
        );        
        let clone = JSON.parse(JSON.stringify(d));
        delete clone.current_doc_view;
        d.current_doc_view = {
          document: clone,
          docStatus: status,
          docHierarchies: d.docHierarchies,
          partsHistory: [],
          wordChecks: d.wordChecks,
          docLanguage: d.documentLanguage
        }         
      })
    },
    changeSideBySideView(){
      this.fullViewPartList = [];
      this.fullViewPartList = this.fullDocParts.map(x => { return x.tmpl_part_id});
      this.docCompareItems.forEach(d => {
        let status = this.statuses.find(
          (x) => x.status === d.doc_status
        );
        let clone = JSON.parse(JSON.stringify(d));
        d.current_doc_view = {
          document: clone,
          docStatus: status,
          docHierarchies: d.docHierarchies,
          partsHistory: [],
          wordChecks: d.wordChecks,
          docLanguage: d.documentLanguage
        } 
      });
    },
    // async syncDocPartAttr(data, parts, attr, part, item){
    //     let relatedItemIdx = item.parts.findIndex(x => x.doc_part_id === part.doc_part_id);
    //     let relatedPartIdx = part.attributes.findIndex(x => x.dpa_id === data.dpa_id);
    //     if(relatedPartIdx > -1){
    //         part.attributes.splice(relatedPartIdx, 1, data);
    //         item.parts.splice(relatedItemIdx,1,parts);
    //         await this.updateDocPart(data, attr, item, parts);
    //     }
    // },
    // processNewDoc(data){
    //   let doc = data.documents[0];
    //   let checks = this.getAllChecks(doc.tmpl_id);
    //   let setup = utils.setupDocument([doc], checks, this.statuses);
    //   if(!this.isDialogue){
    //     this.$store.dispatch("docs/updateDoc", setup.document);
    //   }
    //   let docItem = this.initDocItem(setup.document);
    //   docItem.position_order = 1;
    //   docItem.pinned = true;
    //   docItem.wordChecks = checks;
    //   docItem.docHierarchies = data.docHierarchies;
    //   docItem.checkSummary = utils.documentCheckSummary(
    //     docItem,
    //     docItem.wordChecks,
    //     2
    //   );
    //   let newItem = this.docCompareItems.findIndex(x => x.pinned && x.doc_id === 0 && x.system_reference === " - ");
    //   if(newItem > -1){
    //     this.docCompareItems.splice(newItem, 1, docItem);
    //     // this.loadParts();
    //     this.setConsolidationMode();
    //     this.$emit("triggerNotification", "Document Consolidation Successful!", "success");
    //   }
    // },
    // updateDocInList(data){
    //   let doc = data.documents[0];
    //   let checks = this.getAllChecks(doc.tmpl_id);
    //   let setup = utils.setupDocument([doc], checks, this.statuses);
    //   if(!this.isDialogue){
    //     this.$store.dispatch("docs/updateDoc", setup.document);
    //   }      
    //   let docItem = this.initDocItem(setup.document);
    //   docItem.wordChecks = checks;
    //   docItem.docHierarchies = setup.docHierarchies;
    //   docItem.checkSummary = utils.documentCheckSummary(
    //     docItem,
    //     docItem.wordChecks,
    //     2
    //   );
    //   let newItem = this.docCompareItems.findIndex(x => x.doc_id === doc.doc_id);
    //   if(newItem > -1){
    //     docItem.position_order = this.docCompareItems[newItem].position_order;
    //     this.docCompareItems.splice(newItem, 1, docItem);
    //   }
    // },
    // getLifecycleAction(doc){
    //   let selectedTemplate = this.$loginState.user.createDocumentDialogOptions.find((a) => a.tmpl_name === doc.doc_type);
    //   let selectedActionId = null;
    //   let selectedActionNonDefault = false;
    //   let selectedAction = null;
    //   if (selectedTemplate) {
    //     if (selectedTemplate.lifecycles.length === 1) {
    //       selectedActionId =
    //         selectedTemplate.lifecycles[0].lifecycle_action_id;
    //     } else if (selectedTemplate.lifecycles.length > 1) {
    //       selectedActionId = selectedTemplate.lifecycles.find(
    //         (x) => x.isDefault
    //       ).lifecycle_action_id;
    //     } else {
    //       selectedActionId = null;
    //     }

    //     if (selectedTemplate.lifecyclesHT.length) {
    //     let htTrigger = doc.docHierarchies.find(
    //       (h) =>
    //         h.ht_id === selectedTemplate.lifecyclesHT[0].ht_id_empty_trigger
    //     );
    //     if (htTrigger.hr_id === -999) {
    //       selectedAction = selectedTemplate.lifecyclesHT[0];
    //       htTrigger.hr_id =
    //         this.currentFields && this.currentFields.length
    //           ? this.currentFields[0].value
    //           : "No " + htTrigger.ht_name; // TODO - link to template_lifecycle so is flexible
    //       htTrigger[
    //         "level" +
    //           this.hierarchies.find((x) => x.ht_id === htTrigger.ht_id)
    //             .linklevel
    //       ] = htTrigger.hr_id;
    //       htTrigger.isNew = true;
    //     }
    //   }
    //   if (!selectedAction && selectedTemplate.lifecycles.length) {
    //     if (selectedTemplate.lifecycles.length === 2) {
    //       selectedAction =
    //         selectedTemplate.lifecycles[
    //           selectedActionNonDefault ? 1 : 0
    //         ];
    //     } else {
    //       selectedAction = selectedTemplate.lifecycles.find(
    //         (x) => x.lifecycle_action_id === selectedActionId
    //       );
    //     }
    //   }

    //     return selectedAction;
    //   }
    // },
    // createConsolidated(){

    //   this.consolidateDialog.show = false;

    //   let placeHolder = {
    //     doc_name: "Consolidating.....",
    //     isUpdating: true,
    //     system_reference: " - ",
    //     pinned: true,
    //     checkSummary: {
    //       categories: [],
    //       errors:[],
    //       impactScore: 0,
    //       issueCount:0,
    //       issuePartsCount: 0,
    //       maxIssues: 0,
    //       parts:[],
    //       score:0,
    //       scoreColour:"amber",
    //       warnings:[]
    //     },
    //     doc_status: "DRAFT",
    //     doc_status_text: "Draft",
    //     doc_id:0,
    //     activeParts: []
    //   }

    //   this.docCompareItems.unshift(placeHolder);

    //   axios
    //     .post("document/consolidateDocument/", this.consolidateDialog.data)
    //     .then((resp) => {
    //       if (resp.data.documents.length > 0) {
    //         this.processNewDoc(resp.data);
    //       } else {
    //         alert(resp.data.Message);
    //       }
    //     })
    //     .catch((err) => {
    //       if (err.response && err.response.status === 401) {
    //         this.$emit("sessionExpired", err);
    //       } else {
    //         console.log(err);
    //         this.response = err.response
    //           ? err.response.data
    //           : { message: "Unexpected Error" };
    //       }
    //       this.isLoading = false;
    //     });
    // },
    // setConsolidationMode(){
    //   this.consolidationActions = [];
    //   if(this.validDocumentRange.length > 0){
    //     let actions = this.validDocumentRange.map(d => {
    //       return d.state.actionsAvailable.filter(x => x.lifecycle_status_id_new && !x.lifecycle_role_id_created)
    //     })

    //     this.consolidationActions = actions.reduce((p,c) => p.filter(e => c.map(x => {return x.lifecycle_action_id; }).includes(e.lifecycle_action_id)));
    //   }
    // },
    // consolidateDocument(doc){

    //   let createAction = this.getLifecycleAction(doc);

    //   if(!createAction) { return; }

    //   let populatedData = doc.parttypes.map(t => {
    //     return {
    //       type: t.type,
    //       values: t.parts.filter(p => p.text !== "").map(p => {
    //         return {
    //           text: p.text,
    //           is_essential: p.is_essential,
    //           attributes: t.tmpl_part_metadata.attributes.length > 0 ? p.attributes.map(a => {
    //             return {
    //               tpa_id: a.tpa_id,
    //               tmpl_part_id: a.tmpl_part_id,
    //               text: a.text
    //             }
    //           }) : []
    //         }
    //       }),
    //       merge: t.multi_row ?? t.tmpl_part_metadata.multi_row,
    //       tmpl_part_id: t.tmpl_part_id
    //     }
    //   });

    //   populatedData.forEach(p => {
    //     if(p.merge){
    //       //let current = p.values;

    //       let valid = this.validDocumentRange.map(v => {
    //         let part = v.parttypes.find(d => d.type === p.type);
    //         return part.parts.filter(x => x.text).map(p => { return { 
    //           text: p.text,
    //           is_essential: p.is_essential,
    //           attributes: part.tmpl_part_metadata.attributes.length > 0 ? p.attributes.map(a => {
    //             return {
    //               tpa_id: a.tpa_id,
    //               tmpl_part_id: a.tmpl_part_id,
    //               text: a.text
    //             }
    //           }) : []
    //          } })
    //       }).flat(1)

    //       /*let valid = [...new Set(this.validDocumentRange.map(v => { return v.parttypes.find(d => d.type === p.type).parts.filter(x => x.text).map(p => { return {
    //           text: p.text,
    //           attributes: p.tmpl_part_metadata.attributes.length > 0 ? p.attributes.map(a => {
    //             return {
    //               tpa_id: a.tpa_id,
    //               tmpl_part_id: a.tmpl_part_id,
    //               text: a.text
    //             }
    //           }) : []
    //         }}).flat(1)}).flat(1))];*/
    //       //p.values = [...new Set([...current, ...valid])];
    //       valid.forEach(x => {
    //         if(!p.values.some(v => v.text === x.text)){
    //           p.values.push(x);
    //         }
    //       })
    //     }
    //   })
    //   populatedData = populatedData.filter(t => t.values.length > 0);

    //   let data = {
    //     recruiter: this.$loginState.user.name,
    //     docType: doc.doc_type,
    //     doc_name: doc.doc_name,
    //     hierarchies: doc.docHierarchies.map((h) => {
    //       return { 
    //         hierarchy_text: h.hierarchy_text,
    //         hr_id: h.hr_id,
    //         ht_id: h.ht_id,
    //         ht_name: h.ht_name
    //       }
    //     }),
    //     action: createAction,
    //     populatedData: populatedData,
    //     sourceDocuments: this.validDocumentRange.map(d => { return d.doc_id })
    //   };

    //   this.consolidateDialog = {
    //     message: "",
    //     show: true,
    //     data: data,
    //   }
    // },
    updateDatabaseSelection(item) {
      this.contentDatabaseData = item === "" ? null : item;
    },
    // onChange() {
    //   this.reorderDocs();
    // },
    // reorderDocs() {
    //   this.docCompareItems.forEach(
    //     (item, index) => (item.position_order = index)
    //   );
    // },
    // async setValue(value) {
    //   this.externalContentMenu.show = false;

    //   let sourceDoc = this.docCompareItems.find(
    //     (x) => x.doc_id === this.externalContentMenu.doc
    //   );
    //   let sourceItem = sourceDoc.activeParts.find(
    //     (x) => x.doc_part_id === this.externalContentMenu.part.doc_part_id
    //   );
    //   if (sourceItem) {
    //     let attr = null;
    //     if (
    //       this.externalContentMenu.item.tmpl_part_metadata.attributes.length >=
    //       1
    //     ) {
    //       attr =
    //         this.externalContentMenu.part.attributes[
    //           this.externalContentMenu.part.attributes.length - 1
    //         ];
    //     }
    //     sourceItem.previousValue = sourceItem.text;
    //     await this.saveItemTextInline(
    //       { text: value, highlightedText: value },
    //       sourceDoc,
    //       sourceItem,
    //       attr
    //     );
    //   }

    //   //let resp = await this.updateDocPart({text: value}, attr, this.externalContentMenu.item, this.externalContentMenu.part, true);
    // },
    // doAiFunction(doc, part, functionType) {
    //   this.externalContentMenu.show = false;
    //   this.externalContentMenu.lookupTop = false;
    //   this.suggestionsLoading = true;
    //   //j.doc_id + '|' + item.doc_part_id
    //   let containerRect =
    //     this.$refs[
    //       `menuHolder_${doc.doc_id}|${part.doc_part_id}`
    //     ][0].getBoundingClientRect();
    //   //let container = containerRect;

    //   let xOffset = this.isDialogue ? 13 : doc.pinned ? 112 : 82;
    //   let yOffset = this.isDialogue ? -2 : doc.pinned ? -45 : 45;

    //   this.lookupWidth = containerRect.right - containerRect.left + 15;
    //   this.lookupPosX =
    //     containerRect.left +
    //     (containerRect.right - containerRect.left + 15) -
    //     xOffset;
    //   const vh = Math.max(
    //     document.documentElement.clientHeight || 0,
    //     window.innerHeight || 0
    //   );

    //   //show below textara unless textarea is at bottom of page
    //   if (
    //     containerRect.bottom + this.externalContentMenu.lookupMaxHeight + 2 <
    //     vh
    //   ) {
    //     this.lookupPosY = containerRect.bottom - yOffset;
    //     this.lookupTop = false;
    //   } else {
    //     containerRect =
    //       this.$refs[
    //         `menuTopHolder_${doc.doc_id}|${part.doc_part_id}`
    //       ][0].getBoundingClientRect();
    //     this.lookupPosY = containerRect.top - yOffset;
    //     this.lookupTop = true;
    //   }

    //   this.externalContentMenu = {
    //     ...this.externalContentMenu,
    //     show: true,
    //     lookupTop: this.lookupTop,
    //     lookupPosY: this.lookupPosY,
    //     lookupPosX: this.lookupPosX,
    //     lookupWidth: 320,
    //     part: part,
    //     item: this.targetPartDetails,
    //     doc: doc.doc_id,
    //   };

    //   this.aiMenuData = {
    //     function: functionType,
    //     language: "English", //todo pass in lang
    //     docId: doc.doc_id,
    //     text: part.text,
    //     docLanguage: doc.docLanguage,
    //     suggestionTpId: part.tmpl_part_id,
    //   };
    // },
    // async languageOptionsUpdate(source) {
    //   console.log(source);
    //   let ref =
    //     this.$refs["inline_" + source.doc_id + "_" + source.doc_part_id];
    //   if (ref) {
    //     ref[0].rehighlight();
    //   }
    //   //this.$loginState.user.spellCheck = data;
    //   /*let sourceDoc = this.docCompareItems.find(x => x.doc_id === source.doc_id);
    //   let sourceItem = sourceDoc.activeParts.find(x => x.doc_part_id === source.doc_part_id);
    //   if(sourceItem){
    //     sourceItem.forceRefresh = true;
    //     this.refreshDocs();
    //     await this.$nextTick();
    //     sourceItem.forceRefresh = false;
    //   }*/
    // },
    // toggleInline() {
    //   if (this.useInlineEditor) {
    //     this.refreshDocs();
    //   }
    // },
    // async doSpellReplace(data, source) {
    //   let sourceDoc = this.docCompareItems.find(
    //     (x) => x.doc_id === source.doc_id
    //   );
    //   let sourceItem = sourceDoc.activeParts.find(
    //     (x) => x.doc_part_id === source.doc_part_id
    //   );
    //   if (sourceItem) {
    //     this.closeLanguageMenu();
    //     let attr = null;
    //     if (source.dpa_id) {
    //       attr = sourceItem.attributes.find((x) => x.dpa_id === source.dpa_id);
    //     }
    //     sourceItem.previousValue = sourceItem.text;
    //     await this.saveItemTextInline(
    //       { text: data, highlightedText: data },
    //       sourceDoc,
    //       sourceItem,
    //       attr
    //     );
    //   }
    // },
    updateSuggestionSelection(data) {
      this.suggestedItems = data;
    },
    dragEnd() {
      this.dragging = false;
    },
    initDrag() {
      //console.log("dragging...");
      this.dragging = true;
    },
    dragOverStart() {
      //console.log(event);
    },
    stripTags(text) {
      return text.replace(/(<([^>]+)>)/gi, "");
    },
    clearSuggestions(){
      let ref = this.$refs["suggestionsPanel"];
      if (ref) {
        ref.clearSelection();
        this.dragEnd();
      }
    },
    closeSuggestions() {
      this.showSuggestions = false;
    },
    showSuggestionsPanel() {
      if (this.showDatabase) {
        this.closeDatabase();
      }
      this.showSuggestions = !this.showSuggestions;
    },
    closeDatabase() {
      this.showDatabase = false;
    },
    showDatabasePanel() {
      if (this.showSuggestions) {
        this.closeSuggestions();
      }
      this.showDatabase = !this.showDatabase;
    },
    togglePanel(type) {
      //this.$nextTick(() => {
      this[type] = !this[type];
      //})

      //event.stopPropagation();
      //event.preventDefault();
    },
    // closeLanguageMenu() {
    //   //this.$nextTick(() => {
    //   this.languageMenu.show = false;
    //   //})
    // },
    filterPartDetail() {
      let type = this.summaryMenu.partBreakdown.find(
        (x) => x.type === this.targetPart
      );
      this.summaryMenu.partBreakdown = type
        ? type
        : { type: this.targetPart, issues: [] };
    },
    setTargetPart(type) {
      this.targetPart = type;
      this.loadParts();
      let sourceItem = this.docCompareItems.find(
        (x) => x.doc_id === this.summaryMenu.summaryDoc
      );
      if (sourceItem) {
        this.setSummaryData(sourceItem);
      }
    },
    getIssuesByPart(partList, instance) {
      if (instance.check !== "row_count") {
        let parts = instance.instances.map((x) => x.partsAffected).flat();
        let results = parts.map((x) => {
          let source = partList.find((r) => r.parts.includes(x));
          return source
            ? {
                type: source.type,
                title: instance.title,
              }
            : null;
        });
        return results.filter((x) => x !== null).flat();
      } else {
        let initialPart = instance.instances[0].partsAffected[0];
        let source = partList.find((r) => r.parts.includes(initialPart));
        if (source) {
          return {
            type: source.type,
            title: instance.title,
          };
        }
      }
    },
    getPartSummary(parts, summary) {
      let partList = parts.map((x) => {
        return {
          type: x.type,
          parts: x.parts.map((z) => {
            return z.doc_part_id;
          }),
        };
      });
		parts.forEach(p => utils.childPartTypesToChildParts(p));
      let childPartList = parts
        .filter((x) => x.childPartTypes.length > 0)
        .map((x) => x.parts.filter((z) => z.childParts.length > 0))
        .flat()
        .map((c) => {
          return c.childParts;
        })
        .flat();
      let result = childPartList.reduce((arr, cp) => {
        const values = arr[cp.dp_name];
        arr[cp.dp_name] = values
          ? [...values, cp.doc_part_id]
          : [cp.doc_part_id];
        return arr;
      }, {});
      let childParts = Object.entries(result).map(([type, parts]) => ({
        type,
        parts,
      }));

      let allParts = [...partList, ...childParts];

      let partSummary = [
        ...summary.warnings.map((w) => {
          return this.getIssuesByPart(allParts, w);
        }),
        ...summary.errors.map((e) => {
          return this.getIssuesByPart(allParts, e);
        }),
      ];

      return Object.entries(
        partSummary.flat().reduce(function (acc, curr) {
          let key = acc[curr.type];
          if (!key) {
            return (
              (acc[curr.type] = [
                {
                  issue: curr.title,
                  count: 1,
                },
              ]),
              acc
            );
          } else {
            let exists = key.find((x) => x.issue === curr.title);
            return (
              exists
                ? { ...exists, count: exists.count + 1 }
                : key.push({
                    issue: curr.title,
                    count: 1,
                  }),
              acc
            );
          }
        }, {})
      ).map(([type, issues]) => ({ type, issues }));
    },
    setSummaryData(sourceItem) {
      let summaryDetails = this.getPartSummary(
        sourceItem.parttypes,
        sourceItem.checkSummary
      );
      let partOverview = summaryDetails.map((x) => {
        return {
          type: x.type,
          count: x.issues.length,
        };
      });
      this.summaryMenu.summaryMenuModel = sourceItem.checkSummary;
      this.summaryMenu.partSummary = partOverview;
      this.summaryMenu.partBreakdown = summaryDetails;
    },
    openSummaryMenu(doc_id, event) {
      let sourceItem = this.docCompareItems.find((x) => x.doc_id === doc_id);
      if (sourceItem) {
        this.summaryMenu.display = "category";
        this.setSummaryData(sourceItem);
        this.summaryMenu.summaryDoc = doc_id;

        this.summaryMenu.x = event.clientX;
        this.summaryMenu.y = event.clientY;
        this.summaryMenu.show = true;
      }
    },
    getAllChecks(tmpl_id) {
      let allchecks = this.allChecksData.find((x) => (x.tmpl_id = tmpl_id));
      let tempChecks = allchecks.checks.map((object) => ({ ...object }));
      return utils.initialisePartChecks(tempChecks);
    },
    getWordChecksForPart(tpid, checks, hchys, tmpl_id, attr) {
      let allchecks = this.allChecksData.find((x) => (x.tmpl_id = tmpl_id));
      let tempChecks = allchecks.checks.map((object) => ({ ...object }));
      let filtered = tempChecks.filter((w) =>
        w.tmpl_part_types.some(
          (tp) =>
            tp.tp_id === tpid &&
            (!tp.exclusions.length ||
              !hchys.some((h) =>
                tp.exclusions.some((e) => e.hr_id === h.hr_id)
              ))
        )
      );
      if (attr && attr.skip_checks.length > 0) {
        filtered = filtered.filter(
          (x) => !attr.skip_checks.includes(x.check_type_label)
        );
      }
      return utils.initialisePartChecks(filtered);
    },
    // updateInlineText(doc, item, orig) {
    //   let checks = this.getWordChecksForPart(
    //     item.tmpl_part_id,
    //     doc.wordChecks,
    //     doc.docHierarchies,
    //     doc.tmpl_id
    //   );
    //   let textStatus = utils.applyHighlights(
    //     orig.srcElement.innerText,
    //     checks,
    //     true,
    //     false,
    //     doc
    //   );

    //   item.text = orig.srcElement.innerText;
    //   item.highlightedText = textStatus.highlightedText;
    // },
    // async revertChange(history) {
    //   let processList = [];
    //   let sourceItem = this.docCompareItems.find(
    //     (x) => x.doc_id === history.doc.doc_id
    //   );
    //   if (sourceItem) {
    //     sourceItem.isUpdating = true;
    //   }

    //   if (history.type === "Update") {
    //     let newItem = history.item;
    //     newItem.text = history.diff.old;
    //     processList.push({
    //       doc: history.doc,
    //       item: newItem,
    //       operationType: "save",
    //     });
    //   } else if (history.type === "Add") {
    //     processList.push({
    //       doc: history.doc,
    //       item: history.item,
    //       operationType: "remove",
    //     });
    //   } else if (history.type === "Delete") {
    //     let sourcePart = sourceItem.parttypes.find(
    //       (p) => p.type === history.item.doc_part_type
    //     );
    //     let seq =
    //       Math.max(
    //         ...sourcePart.parts.map((x) => {
    //           return x.sequence;
    //         })
    //       ) + 1;
    //     processList.push({
    //       doc: history.doc,
    //       item: history.item,
    //       operationType: "revert",
    //       sequence: seq,
    //     });
    //   }

    //   let idx = this.historyItems.indexOf(history);
    //   this.historyItems.splice(idx, 1);
    //   this.historyItems = JSON.parse(JSON.stringify(this.historyItems));

    //   if (this.historyItems.length === 0) {
    //     this.historyUndoDialog = {
    //       message: "",
    //       show: false,
    //       data: [],
    //     };
    //     this.historyFilter = false;
    //   }

    //   let partType = history.item.doc_part_type;

    //   await Promise.all(
    //     processList.map(async (update) => {
    //       switch (update.operationType) {
    //         case "save":
    //           return await this.updateDocPart(
    //             update.doc,
    //             update.item,
    //             update.item.sequence,
    //             partType,
    //             false
    //           );
    //         case "remove":
    //           return await this.removeDocPart(
    //             update.doc,
    //             update.item.doc_part_id,
    //             false
    //           );
    //         case "revert":
    //           return await this.undoRemoveDocPart(
    //             update.doc,
    //             update.item.doc_part_id,
    //             update.sequence
    //           );
    //       }
    //     })
    //   ).then((resps) => {
    //     this.processResults(resps);
    //   });
    // },
    // confirmUndo() {
    //   this.historyUndoDialog = {
    //     message: "",
    //     show: false,
    //     data: [],
    //   };
    // },
    // undoHistory() {
    //   let items = this.historyItems.filter((x) => x.selected);
    //   this.historyUndoDialog = {
    //     message: `Are you sure you want to undo ${items.length} action(s)`,
    //     show: true,
    //     data: items,
    //   };
    // },
    // toggleAllHistory() {
    //   this.historyItems = this.historyItems.map((x) => {
    //     return {
    //       ...x,
    //       selected: this.historySelectAll,
    //     };
    //   });
    // },
    // toggleHistoryItem(item) {
    //   item.selected = !item.selected;
    //   this.historyItems = JSON.parse(JSON.stringify(this.historyItems));
    // },
    openContext($event, j) {
      this.$emit("openContext", $event, j);
    },
    // removeView(type, doc) {
    //   let sourceItem = this.docCompareItems.find(
    //     (x) => x.doc_id === doc.doc_id
    //   );
    //   if (sourceItem) {
    //     switch (type) {
    //       case "unlock":
    //         sourceItem.locked = false;
    //         break;
    //       case "view":
    //         sourceItem.visible = true;
    //         break;
    //     }
    //   }
    //   this.refreshDocs();
    //   if (this.docDisplayItems.length === 0) {
    //     this.viewFilter = false;
    //   }
    // },
    // toggleAllParts(doc) {
    //   let sourceItem = this.docCompareItems.find(
    //     (x) => x.doc_id === doc.doc_id
    //   );
    //   if (sourceItem) {
    //     let val = doc.allSelected ? true : false;
    //     sourceItem.activeParts.forEach((x) => {
    //       x.selected = val;
    //       this.selectPart(doc.doc_id, x, false);
    //     });
    //   }

    //   this.updateDocCheckStatus(doc.doc_id);
    //   this.refreshDocs();
    // },
    // addNewItem(doc, editOnAdd) {
    //   this.addNewRow(doc, editOnAdd);
    //   this.refreshDocs();
    // },
    // addNewRow(
    //   doc,
    //   editOnAdd = true,
    //   overrideText = "",
    //   partType = "",
    //   tmpl_part_id = "",
    //   doc_part_id = 0,
    //   addToDoc = true,
    //   fullObj = null
    // ) {
    //   //let sourceItem = this.docCompareItems.find(x => x.doc_id === doc.doc_id);
    //   //if(sourceItem){
    //   let targetPart = partType === "" ? this.targetPart : partType;
    //   let sourceList = doc.parttypes.find((x) => x.type === targetPart);
    //   let copyItem = sourceList.parts[0];
    //   let newItem = this.clone(copyItem);
    //   newItem.tmpl_part_metadata = sourceList.tmpl_part_metadata;
    //   newItem.text = overrideText;
    //   if (newItem.subParts.length === 0) {
    //     newItem.subParts.push({
    //       text: overrideText,
    //       type: "text",
    //       editing: false,
    //     });
    //   } else {
    //     newItem.subParts[0].text = overrideText;
    //   }
    //   if (this.useInlineEditor) {
    //     editOnAdd = false;
    //   }
    //   newItem.compareHtml = "";
    //   newItem.editing = editOnAdd;

    //   if (doc_part_id > 0) {
    //     newItem.doc_part_id = doc_part_id;
    //   }

    //   let tmpl_part = copyItem ? copyItem.tmpl_part_id : tmpl_part_id;

    //   let checks = this.getWordChecksForPart(
    //     tmpl_part,
    //     doc.wordChecks,
    //     doc.docHierarchies,
    //     doc.tmpl_id
    //   );
    //   newItem.wordChecks = checks;

    //   if (newItem.tmpl_part_metadata.attributes.length >= 1) {
    //     newItem.attributes.forEach((a) => {
    //       let itemSource = fullObj
    //         ? fullObj.attributes.find((x) => x.tpa_id === a.tpa_id)
    //         : newItem.tmpl_part_metadata.attributes.find(
    //             (x) => x.tpa_id === a.tpa_id
    //           );
    //       a.text = fullObj ? itemSource.text : itemSource.default_text;
    //       let attrChecks = this.getWordChecksForPart(
    //         tmpl_part,
    //         doc.wordChecks,
    //         doc.docHierarchies,
    //         doc.tmpl_id,
    //         a
    //       );
    //       a.wordChecks = attrChecks;
    //     });
    //   }

    //   if (overrideText !== "") {
    //     //let checks = this.getWordChecksForPart(tmpl_part,doc.wordChecks,doc.docHierarchies,doc.tmpl_id);
    //     newItem.textStatus = utils.applyHighlights(
    //       overrideText,
    //       checks,
    //       true,
    //       false
    //     );
    //     newItem.highlightedText = newItem.textStatus.highlightedText;
    //   }

    //   let sequence = doc.activeParts.length
    //     ? doc.activeParts.reduce(
    //         (pval, cval) => (pval > cval.sequence ? pval : cval.sequence),
    //         0
    //       ) + 1
    //     : 1;
    //   newItem.sequence = sequence;
    //   if (addToDoc) {
    //     doc.activeParts.push(newItem);
    //     //this.refreshDocs();
    //   }

    //   return newItem;
    //   //}
    // },
    // async confirmDelete() {
    //   this.deleteConfirmDialog.show = false;
    //   let sourceItem = this.docCompareItems.find(
    //     (x) => x.doc_id === this.deleteConfirmDialog.data.doc.doc_id
    //   );
    //   if (sourceItem) {
    //     sourceItem.isUpdating = true;
    //     let addEmpty =
    //       this.deleteConfirmDialog.data.items.length ===
    //       sourceItem.activeParts.length;
    //     if (addEmpty) {
    //       let tmpl_part_id = sourceItem.parttypes.find(
    //         (x) => x.type === this.targetPart
    //       ).tmpl_part_id;
    //       let newRow = this.addNewRow(
    //         this.deleteConfirmDialog.data.doc,
    //         false,
    //         "",
    //         this.targetPart,
    //         tmpl_part_id,
    //         0,
    //         false
    //       );
    //       this.deleteConfirmDialog.data.items.push({
    //         ...newRow,
    //         operationType: "save",
    //       });
    //     }
    //   }
    //   let partType = this.targetPart;

    //   await Promise.all(
    //     this.deleteConfirmDialog.data.items.map(async (item) => {
    //       switch (item.operationType) {
    //         case "remove":
    //           return await this.removeDocPart(
    //             this.deleteConfirmDialog.data.doc,
    //             item.doc_part_id
    //           );
    //         case "save":
    //           return await this.updateDocPart(
    //             this.deleteConfirmDialog.data.doc,
    //             item,
    //             item.sequence,
    //             partType
    //           );
    //       }
    //     })
    //   ).then((resps) => {
    //     this.processResults(resps);
    //     sourceItem.isUpdating = false;
    //     this.deleteConfirmDialog = {
    //       message: "",
    //       show: false,
    //       data: [],
    //     };
    //   });
    // },
    // deleteItems(doc) {
    //   if (this.selectedActiveParts.length) {
    //     let items = this.selectedActiveParts.filter(
    //       (x) => x.doc_id === doc.doc_id
    //     );

    //     this.deleteConfirmDialog = {
    //       message: `Are you sure you want to delete ${items.length} items?`,
    //       show: true,
    //       data: {
    //         doc: doc,
    //         items: items.map((x) => {
    //           return {
    //             ...x,
    //             operationType: "remove",
    //           };
    //         }),
    //       },
    //     };
    //   }
    // },
    // cancelEdit(doc, item) {
    //   item.text = item.previousValue;
    //   item.editing = !item.editing;

    //   if (item.doc_part_id === 0 || item.doc_part_id === undefined) {
    //     let idx = doc.activeParts.indexOf(item);
    //     if (idx > -1) {
    //       doc.activeParts.splice(idx, 1);
    //     }
    //   }

    //   this.refreshDocs();
    // },
    // async saveItemText(doc, item) {
    //   let partType = this.targetPart;
    //   item.editing = false;
    //   if (item.text !== item.previousValue) {
    //     doc.isUpdating = true;
    //     const updateRequest = this.updateDocPart(
    //       doc,
    //       item,
    //       item.sequence,
    //       partType
    //     );
    //     await updateRequest
    //       .then((resps) => {
    //         this.processResults([resps]);
    //       })
    //       .then(() => {
    //         if (this.isComparing) {
    //           this.compareTest();
    //         }
    //       });
    //   }
    // },
    // async saveItemTextInline(text, doc, item, attr = null, returnVal = false) {
    //   let partType = this.targetPart;
    //   item.editing = false;
    //   const previousValue = text.previousValue || item.previousValue;
    //   if (text.text !== previousValue) {
    //     doc.isUpdating = true;
    //     item.text = text.text;
    //     item.highlightedText = text.highlightedText;
    //     item.textStatus = text;
    //     if (!returnVal) {
    //       const updateRequest = this.updateDocPart(
    //         doc,
    //         item,
    //         item.sequence,
    //         partType,
    //         true,
    //         attr
    //       );
    //       await updateRequest
    //         .then((resps) => {
    //           this.processResults([resps]);
    //         })
    //         .then(() => {
    //           if (this.isComparing) {
    //             this.compareTest();
    //           }
    //         });
    //     } else {
    //       return this.updateDocPart(
    //         doc,
    //         item,
    //         item.sequence,
    //         partType,
    //         true,
    //         attr
    //       );
    //     }
    //   }
    // },
    // doubleClickTrigger(doc, item) {
    //   if (doc.locked || doc.lockedByPermission || item.editing) {
    //     return;
    //   }

    //   let partChecks = this.getWordChecksForPart(
    //     item.tmpl_part_id,
    //     null,
    //     doc.docHierarchies,
    //     doc.tmpl_id
    //   );
    //   item.wordChecks = partChecks;

    //   item.previousValue = item.text;
    //   item.editing = !item.editing;
    //   if (this.isComparing && item.compareHtml !== "") {
    //     item.compareHtml = "";
    //   }
    //   this.refreshDocs();
    // },
    showHierarchyFilter(val) {
      this.$emit("showHierarchyFilter", val);
    },
    openDocument(item) {
      this.$emit("openDoc", item);
    },
    // doHierarchyFilter(hierarchyFilters, classifierFilters) {
    //   this.$emit("doHierarchyFilter", hierarchyFilters, classifierFilters);
    // },
    // refreshDocs() {
    //   this.$nextTick(() => {
    //     this.docCompareItems = this.docCompareItems.map((object) => ({
    //       ...object,
    //     }));
    //   });
    //   //this.$nextTick(function(){
    //   //});

    //   //this.docCompareItems = JSON.parse(JSON.stringify(this.docCompareItems));
    // },
    // selectPart(doc_id, item, update = true) {
    //   let existing = this.selectedActiveParts.find(
    //     (x) => x.doc_id === doc_id && x.doc_part_id === item.doc_part_id
    //   );
    //   if (existing) {
    //     let idx = this.selectedActiveParts.indexOf(existing);
    //     this.selectedActiveParts.splice(idx, 1);
    //   }

    //   if (item.selected) {
    //     let attrs = [];

    //     if (item.tmpl_part_metadata.attributes.length >= 1) {
    //       attrs = item.attributes.map((a) => {
    //         return {
    //           ...a,
    //         };
    //       });
    //     }

    //     let obj = {
    //       doc_id: doc_id,
    //       doc_part_id: item.doc_part_id,
    //       text: item.text,
    //       attributes: attrs,
    //     };

    //     this.selectedActiveParts.push(obj);
    //   }

    //   if (update) {
    //     this.updateDocCheckStatus(doc_id);
    //     this.refreshDocs();
    //   }
    // },
    // updateDocCheckStatus(doc_id) {
    //   let source = this.docCompareItems.find((x) => x.doc_id === doc_id);
    //   let selected = this.selectedActiveParts.filter(
    //     (x) => x.doc_id === doc_id
    //   );
    //   source.indeterminate = false;
    //   if (selected.length === 0) {
    //     source.allSelected = false;
    //     return;
    //   }

    //   if (selected.length === source.activeParts.length) {
    //     source.allSelected = true;
    //     return;
    //   }
    //   if (selected.length > 0 && selected.length < source.activeParts.length) {
    //     source.indeterminate = true;
    //   }
    // },
    docEditable(target){
      if (
        target.state.canEditDocParts &&
        !target.locked &&
        !target.lockedByPermission
      ) {
        return true;
      }
      return false;
    },
    // checkMove(evt) {
    //   let target = this.docCompareItems.find(
    //     (x) => x.doc_id === Number(evt.to.id)
    //   );
    //   if (
    //     target.state.canEditDocParts &&
    //     !target.locked &&
    //     !target.lockedByPermission
    //   ) {
    //     return true;
    //   }
    //   return false;
    // },
    // saveItemOrder(data){
    //   let processPromise = new Promise((resolve, reject) => {
    //     axios
    //       .post("document/savedocpartsequence/", data)
    //       .then((resp) => {
    //         resolve(resp);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });

    //   return processPromise;    
    // }, 
    // async changeOrder(item, save){
    //     let data = item.activeParts.map((r, i) => {
    //         let ret = {};
    //         ret.sequence = i + 1;
    //         ret.type = this.targetPart;
    //         ret.doc_part_id = r.doc_part_id;
    //         return ret;
    //     });

    //     if(save){
    //         await this.saveItemOrder(data);
		// 	item.parttypes.find((p) => p.type === this.targetPart).parts = item.activeParts.map((object) => ({ ...object }));
    //         this.$emit("triggerNotification", "Part Order Updated","success");
    //     }

        
    // },
    // async checkEnd(evt) {
    //   if (evt.to.id === evt.from.id) {
    //     if(evt.newIndex !== evt.oldIndex){
    //       //same doc drag_drop => reorder
    //       let source = this.docCompareItems.find((x) => x.doc_id === Number(evt.from.id));
    //       await this.changeOrder(source, true);
    //     }
    //     return;
    //   }
    //   this.updateSourceDoc(evt);
    // },
    // clearSelected() {
    //   this.selectedActiveParts = [];
    //   this.docCompareItems.forEach((x) => {
    //     x.activeParts.forEach((p) => {
    //       p.selected = false;
    //     });
    //     this.updateDocCheckStatus(x.doc_id);
    //   });
    // },
    // async updateSourceDoc(event) {
    //   let processList = [];
    //   let sourceItems = this.docCompareItems.find(
    //     (x) => x.doc_id === Number(event.from.id)
    //   );
    //   let targetItems = this.docCompareItems.find(
    //     (x) => x.doc_id === Number(event.to.id)
    //   );

    //   let item = event.clone.id.split("|");

    //   if (targetItems.locked || targetItems.lockedByPermission) {
    //     return;
    //   }

    //   targetItems.isUpdating = true;
    //   let tmpl_differ = sourceItems.tmpl_id !== targetItems.tmpl_id;
    //   let target_tp = tmpl_differ
    //     ? targetItems.parttypes.find((x) => x.type === this.targetPart)
    //         .tmpl_part_id
    //     : sourceItems.parttypes.find((x) => x.type === this.targetPart)
    //         .tmpl_part_id;
    //   let originalItem = Number(event.item.id.split("|")[1]);
    //   let draggedItem =
    //     targetItems.activeParts[event.newIndex] ??
    //     sourceItems.activeParts.find((x) => x.doc_part_id === Number(item[1]));
    //   let dragType = this.pullFunction() === "clone" ? "clone" : "replace";
    //   let targetMethod = this.isMultiPart ? "add" : "replace";
    //   if (dragType === "replace") {
    //     if (this.selectedActiveParts.length) {
    //       this.selectedActiveParts.forEach((sp) => {
    //         let docGroup = this.docCompareItems.find(
    //           (x) => x.doc_id === sp.doc_id
    //         );
    //         docGroup.isUpdating = true;
    //         processList.push({
    //           type: "remove",
    //           doc: docGroup,
    //           doc_part_id: sp.doc_part_id,
    //         });
    //         let source_item = docGroup.activeParts.find(
    //           (x) => x.text === sp.text
    //         );
    //         if (source_item) {
    //           let source_idx = docGroup.activeParts.indexOf(source_item);
    //           docGroup.activeParts.splice(source_idx, 1);
    //         }
    //       });

    //       let draggedOriginalSelected = this.selectedActiveParts.find(
    //         (x) => x.doc_part_id === originalItem
    //       );
    //       if (!draggedOriginalSelected) {
    //         sourceItems.isUpdating = true;
    //         processList.push({
    //           type: "remove",
    //           doc: sourceItems,
    //           doc_part_id: originalItem,
    //         });
    //       }
    //     } else {
    //       if (targetMethod === "add") {
    //         sourceItems.isUpdating = true;
    //         processList.push({
    //           type: "remove",
    //           doc: sourceItems,
    //           doc_part_id: originalItem,
    //         });
    //       }
    //     }

    //     if (sourceItems.activeParts.length === 0) {
    //       let copy = JSON.parse(JSON.stringify(draggedItem));
    //       copy.text = "";
    //       sourceItems.isUpdating = true;
    //       copy.doc_part_id = Number(originalItem);
    //       //sourceItems.activeParts.push(copy);
    //       processList.push({
    //         type: "save",
    //         doc: sourceItems,
    //         item: copy,
    //         sequence: 1,
    //       });
    //     }
    //   }

    //   let idx = event.newIndex;

    //   switch (targetMethod) {
    //     case "replace":
    //       targetItems.activeParts.splice(idx, 1);
    //       targetItems.activeParts[0].text = draggedItem.text;
    //       processList.push({
    //         type: "save",
    //         doc: targetItems,
    //         item: targetItems.activeParts[0],
    //         sequence: targetItems.activeParts[0].sequence,
    //       });
    //       break;
    //     case "add":
    //       targetItems.activeParts.splice(idx, 1);
    //       if (this.selectedActiveParts.length) {
    //         this.selectedActiveParts.forEach((sp) => {
    //           let newItem = this.clone(targetItems.activeParts[0]);
    //           newItem.text = sp.text;
    //           newItem.tmpl_part_id = target_tp;
    //           if (sp.attributes.length >= 1) {
    //             newItem.attributes.forEach((na) => {
    //               let sourceAtt = sp.attributes.find(
    //                 (x) => x.tpa_id === na.tpa_id
    //               );
    //               na.text = sourceAtt.text;
    //             });
    //           }
    //           processList.push({
    //             type: "save",
    //             doc: targetItems,
    //             item: newItem,
    //             sequence: idx + 1,
    //           });
    //         });

    //         let draggedOriginalSelected = this.selectedActiveParts.find(
    //           (x) => x.doc_part_id === originalItem
    //         );
    //         if (!draggedOriginalSelected) {
    //           let newItem = this.clone(targetItems.activeParts[0]);
    //           newItem.text = draggedItem.text;
    //           newItem.tmpl_part_id = target_tp;
    //           processList.push({
    //             type: "save",
    //             doc: targetItems,
    //             item: newItem,
    //             sequence: idx + 1,
    //           });
    //         }
    //       } else {
    //         let newItem = this.clone(draggedItem);
    //         newItem.text = draggedItem.text;
    //         newItem.tmpl_part_id = target_tp;
    //         if (draggedItem.tmpl_part_metadata.attributes.length >= 1) {
    //           newItem.attributes.forEach((na) => {
    //             let sourceAtt = draggedItem.attributes.find(
    //               (x) => x.tpa_id === na.tpa_id
    //             );
    //             na.text = sourceAtt.text;
    //           });
    //         }
    //         processList.push({
    //           type: "save",
    //           doc: targetItems,
    //           item: newItem,
    //           sequence: idx + 1,
    //         });
    //       }

    //       break;
    //   }

    //   this.refreshDocs();
    //   let partType = this.targetPart;
    //   await Promise.all(
    //     processList.map(async (item) => {
    //       switch (item.type) {
    //         case "remove":
    //           return await this.removeDocPart(item.doc, item.doc_part_id);
    //         case "save":
    //           return await this.updateDocPart(
    //             item.doc,
    //             item.item,
    //             item.sequence,
    //             partType
    //           );
    //       }
    //     })
    //   ).then((resps) => {
    //     this.processResults(resps);
    //     this.clearSelected();
    //   });
    // },
    // removeItemFromDoc(doc_id, item) {
    //   let sourceItem = this.docCompareItems.find((x) => x.doc_id === doc_id);
    //   sourceItem.isUpdating = false;
    //   if (sourceItem) {
    //     let aIdx = sourceItem.activeParts.find((a) => a.doc_part_id === item);
    //     if (aIdx) {
    //       sourceItem.activeParts.splice(
    //         sourceItem.activeParts.indexOf(aIdx),
    //         1
    //       );
    //     }
    //     let sourcePart = sourceItem.parttypes.find(
    //       (p) => p.type === this.targetPart
    //     );
    //     let iIdx = sourcePart.parts.find((a) => a.doc_part_id === item);
    //     if (iIdx) {
    //       sourcePart.parts.splice(sourcePart.parts.indexOf(iIdx), 1);
    //     }
    //     let selectedItem = this.selectedActiveParts.find(
    //       (x) => x.doc_part_id === item
    //     );
    //     if (selectedItem) {
    //       this.selectedActiveParts.splice(
    //         this.selectedActiveParts.indexOf(selectedItem),
    //         1
    //       );
    //     }
    //   }
    // },
    // addNewItemToDoc(source, newItem, newAttrs) {
    //   let sourceItem = this.docCompareItems.find(
    //     (x) => x.doc_id === source.doc_id
    //   );
    //   let sourcePart = sourceItem.parttypes.find(
    //     (x) => x.type === source.doc_part_type
    //   );

    //   if (newItem["tmpl_part_id"] === undefined) {
    //     newItem.tmpl_part_id = sourcePart.tmpl_part_id;
    //   }
    //   let addedItem = sourceItem.activeParts.find(
    //     (x) => x.text === source.text && x.doc_part_id === source.doc_part_id
    //   );
    //   if (addedItem) {
    //     addedItem.doc_part_id = Number(newItem.doc_part_id);
    //     sourcePart.parts.push(addedItem);
    //   } else {
    //     let tmpl_part_id = sourceItem.parttypes.find(
    //       (x) => x.type === this.targetPart
    //     ).tmpl_part_id;
    //     let cloned = this.addNewRow(
    //       sourceItem,
    //       false,
    //       source.text,
    //       newItem.dp_name,
    //       tmpl_part_id,
    //       Number(newItem.doc_part_id),
    //       false,
    //       source
    //     );
    //     let restored = this.updateFromAudit(newItem, cloned, newAttrs);
    //     sourceItem.activeParts.push(restored);
    //     //let sourcePart = sourceItem.parttypes.find(p => p.type === newItem.dp_name);
    //     sourcePart.parts.push(restored);
    //   }
    // },
    // updateItemInDoc(source, newItem, newAttrs) {
    //   let list = this.docCompareItems.find((x) => x.doc_id === source.doc_id);
    //   list.isUpdating = false;
    //   list.editing = false;

    //   let sourcePart = list.parttypes.find(
    //     (x) => x.type === source.doc_part_type
    //   );
    //   let checks = this.getWordChecksForPart(
    //     source.tmpl_part_id,
    //     list.wordChecks,
    //     list.docHierarchies,
    //     list.tmpl_id
    //   );

    //   let existingPart = list.activeParts.find(
    //     (x) => x.doc_part_id === source.doc_part_id
    //   );
    //   if (existingPart) {
    //     existingPart.text = source.text;
    //     existingPart.textStatus = utils.applyHighlights(
    //       source.text,
    //       checks,
    //       true,
    //       false
    //     );
    //     existingPart.highlightedText = existingPart.textStatus.highlightedText;
    //     if (newAttrs) {
    //       newAttrs.forEach((a) => {
    //         let updateItem = existingPart.attributes.find(
    //           (x) => x.tpa_id === a.tpa_id
    //         );
    //         updateItem.doc_part_id = Number(newItem.doc_part_id);
    //         updateItem.dpa_id = Number(a.dpa_id);
    //       });
    //     }
    //   }
    //   let existingItem = sourcePart.parts.find(
    //     (x) => x.doc_part_id === source.doc_part_id
    //   );
    //   if (existingItem) {
    //     existingItem.text = source.text;
    //     existingItem.textStatus = utils.applyHighlights(
    //       source.text,
    //       checks,
    //       true,
    //       false
    //     );
    //     existingItem.highlightedText = existingItem.textStatus.highlightedText;
    //     if (newAttrs) {
    //       newAttrs.forEach((a) => {
    //         let updateItem = existingPart.attributes.find(
    //           (x) => x.tpa_id === a.tpa_id
    //         );
    //         updateItem.doc_part_id = Number(newItem.doc_part_id);
    //         updateItem.dpa_id = Number(a.dpa_id);
    //       });
    //     }
    //   } else{
    //     if(newItem && !existingItem && existingPart){
    //       this.addNewItemToDoc(source, newItem, newAttrs);
    //     }
    //   }

    //   if (newItem && !existingPart && !existingItem) {
    //     this.addNewItemToDoc(source, newItem, newAttrs);
    //   }
    // },
    // updateFromAudit(newRow, cloned, newAttrs) {
    //   let updated = {
    //     ...cloned,
    //     doc_part_id: Number(newRow.doc_part_id),
    //   };

    //   if (newAttrs && newAttrs.length > 0) {
    //     updated.attributes.forEach((a) => {
    //       let sourceAttr = newAttrs.find((x) => x.tpa_id === a.tpa_id);
    //       if (sourceAttr) {
    //         a.dpa_id = Number(sourceAttr.dpa_id);
    //         a.doc_part_id = Number(sourceAttr.dp_id);
    //         a.text = sourceAttr.value;
    //       }
    //     });
    //   }

    //   return updated;
    // },
    // restoreDelete(doc_id, newRow, newRowAttributes) {
    //   let sourceItem = this.docCompareItems.find((x) => x.doc_id === doc_id);
    //   if (sourceItem) {
    //     let cloned = this.addNewRow(
    //       sourceItem,
    //       false,
    //       newRow.text,
    //       newRow.dp_name
    //     );
    //     let restored = this.updateFromAudit(newRow, cloned, newRowAttributes);
    //     let sourcePart = sourceItem.parttypes.find(
    //       (p) => p.type === newRow.dp_name
    //     );
    //     sourcePart.parts.push(restored);
    //     sourceItem.isUpdating = false;
    //   }
    // },
    // processResults(resps) {
    //   let messages = [];
    //   let docs = [];
    //   let reverse = [...new Set(resps.map((x) => x.type))].length > 1;
    //   if (reverse) {
    //     resps = resps.reverse();
    //   }
    //   resps.forEach((r) => {
    //     let type = r.type;
    //     let source = r.request;
    //     let result = r.result.Data;
    //     switch (type) {
    //       case "Updated":
    //         this.updateItemInDoc(
    //           source,
    //           r.result.Data.newRow,
    //           r.result.Data.newRowAttributes
    //         );
    //         break;
    //       case "Removed":
    //         this.removeItemFromDoc(source.doc_id, result.audit.key);
    //         break;
    //       case "Reverted":
    //         this.restoreDelete(
    //           source.doc_id,
    //           result.newRow,
    //           result.newRowAttributes
    //         );
    //     }

    //     let list = this.docCompareItems.find((x) => x.doc_id === source.doc_id);

    //     messages.push(
    //       `${source.system_number} Updated: ${source.doc_part_type} ${type}`
    //     );

    //     docs.push(source.doc_id);

    //     if (
    //       this.summaryMenu.show &&
    //       this.summaryMenu.summaryDoc === source.doc_id
    //     ) {
    //       this.setSummaryData(list);
    //     }
    //   });

    //   let updateDocs = [...new Set(docs)];
    //   updateDocs.forEach((d) => {
    //     this.updateDocCheckStatus(d);
    //     this.refreshCheckSummary(d);
    //   });

    //   this.refreshDocs();

    //   if (messages.length) {
    //     this.$emit("triggerNotification", messages.join("<br/>"), "success");
    //   }
    // },
    refreshCheckSummary(d) {
      let sourceItem = this.docCompareItems.find((x) => x.doc_id === d);
      if (sourceItem) {
        let allChecks = this.getAllChecks(sourceItem.tmpl_id);
        sourceItem.checkSummary = utils.documentCheckSummary(
          sourceItem,
          allChecks,
          2
        );
      }
    },
    // async undoRemoveDocPart(doc, doc_part_id, sequence) {
    //   let processPromise = new Promise((resolve, reject) => {
    //     let data = {
    //       doc_part_id: doc_part_id,
    //       doc_part_type: this.targetPart,
    //       sequence: sequence,
    //     };

    //     axios
    //       .post("document/undoremovedocpart/", data)
    //       .then((resp) => {
    //         resolve({
    //           type: "Reverted",
    //           request: { ...doc, ...data },
    //           result: resp.data,
    //         });
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });

    //   return processPromise;
    // },
    // async removeDocPart(doc, doc_part_id, addHistory = true) {
    //   let processPromise = new Promise((resolve, reject) => {
    //     let data = {
    //       doc_part_id: doc_part_id,
    //       doc_part_type: this.targetPart,
    //     };

    //     axios
    //       .post("document/removedocpart/", data)
    //       .then((resp) => {
    //         if (addHistory) {
    //           this.historyItems.unshift({
    //             type: "Delete",
    //             selected: false,
    //             doc: { doc_id: doc.doc_id, system_number: doc.system_number },
    //             item: data,
    //           });
    //         }
    //         resolve({
    //           type: "Removed",
    //           request: { ...doc, ...data },
    //           result: resp.data,
    //         });
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });

    //   return processPromise;
    // },
    // async updateDocPart(
    //   targetDoc,
    //   item,
    //   sequence,
    //   type,
    //   addHistory = true,
    //   attr
    // ) {
    //   let processPromise = new Promise((resolve, reject) => {
    //     let isAttr = item.tmpl_part_metadata.attributes?.length >= 1;

    //     if (isAttr && attr) {
    //       attr.isDirty = true;
    //       //attr.isDirty = data.text !== attr.text;
    //       attr.text = item.text;
    //       item.text = utils.attributesToText(
    //         item.tmpl_part_metadata.attributes,
    //         item.attributes
    //       );
    //       item.subParts = utils.partToSubParts(item.text);
    //     }

    //     let data = {
    //       text: item.text,
    //       doc_part_id: item.doc_part_id,
    //       doc_part_type: type,
    //       doc_id: targetDoc.doc_id,
    //       system_number: targetDoc.system_number,
    //       tmpl_part_id: item.tmpl_part_id,
    //       notes: null,
    //       parent_dp_id: null,
    //       is_essential: item.is_essential,
    //       quality: 0,
    //       sequence: sequence,
    //       tmpl_part_metadata: item.tmpl_part_metadata,
    //       attributes: isAttr
    //         ? item.attributes
    //             .filter((a) => a.isDirty)
    //             .map((a) => {
    //               return { tpa_id: a.tpa_id, dpa_id: a.dpa_id, text: a.text };
    //             })
    //         : [],
    //     };

    //     axios
    //       .post("document/savedocpart/", data)
    //       .then((resp) => {
    //         if (addHistory) {
    //           let historyType = item.doc_part_id === 0 ? "Add" : "Update";

    //           if (historyType === "Add") {
    //             data.doc_part_id = Number(resp.data.Data.audit.key);
    //             item.doc_part_id = Number(resp.data.Data.audit.key);
    //           }

    //           this.historyItems.unshift({
    //             type: historyType,
    //             selected: false,
    //             doc: {
    //               doc_id: targetDoc.doc_id,
    //               system_number: targetDoc.system_number,
    //             },
    //             item: data,
    //             diff:
    //               historyType === "Add"
    //                 ? null
    //                 : {
    //                     old: item.previousValue,
    //                     new: item.text,
    //                     content: this.runCompare(item.previousValue, item.text),
    //                   },
    //           });
    //         }
    //         this.refreshDocs();
    //         resolve({ type: "Updated", request: data, result: resp.data });
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });

    //   return processPromise;
    // },
    // clone(item) {
    //   let newItem = Object.assign({}, item);
    //   delete newItem.doc_part_id;
    //   //delete newItem.highlightedText;
    //   delete newItem.text;
    //   delete newItem.subParts;
    //   delete newItem.previousValue;

    //   newItem = {
    //     ...newItem,
    //     doc_part_id: 0,
    //     text: "",
    //     editing: false,
    //     highlightedText: "",
    //     previousValue: "",
    //     subParts: [],
    //     is_essential: null
    //   };

    //   if (newItem.attributes) {
    //     newItem.attributes = item.attributes.map((object) => ({ ...object }));
    //     newItem.attributes.forEach((a) => {
    //       a.doc_part_id = 0;
    //       a.dpa_id = 0;
    //       a.isDirty = true;
    //       a.text = "";
    //     });
    //   }

    //   return newItem;
    // },
    // pullFunction() {
    //   return !this.controlOnStart ? "clone" : true;
    // },
    // start({ originalEvent }) {
    //   this.controlOnStart = originalEvent.ctrlKey;
    // },
    // clearLocked() {
    //   this.lockedDocs.forEach((x) => (x.locked = false));
    //   this.refreshDocs();
    // },
    // runCompare(source, compare) {
    //   const diff = JsDiff[this.diffType](source, compare, {
    //     ignoreWhitespace: false,
    //   });
    //   let returnString = "";
    //   diff.forEach((part) => {
    //     const color = part.added ? "green" : part.removed ? "red" : "grey";
    //     let fragment = "";
    //     switch (color) {
    //       case "green":
    //         fragment = `<ins>${part.value}</ins>`;
    //         break;
    //       case "red":
    //         fragment = `<del>${part.value}</del>`;
    //         break;
    //       case "grey":
    //         fragment = `${part.value}`;
    //         break;
    //     }
    //     returnString = returnString += fragment;
    //   });

    //   return returnString;
    // },
    // clearCompare() {
    //   this.isComparing = false;
    //   this.docCompareItems = this.docCompareItems.map((d) => {
    //     return {
    //       ...d,
    //       activeParts: d.activeParts.map((p) => {
    //         return { ...p, compareHtml: "" };
    //       }),
    //     };
    //   });
    //   this.refreshDocs();
    // },
    // compareTest() {
    //   this.compareLoading = true;
    //   let source = this.pinnedDoc;
    //   if (source.activeParts.length === 1) {
    //     let compareSource = source.activeParts[0].text;
    //     this.activeDocs.forEach((i) => {
    //       if (i.activeParts.length >= 1) {
    //         let compareText = i.activeParts[0].text;
    //         let compareHtml = this.runCompare(compareSource, compareText);
    //         i.activeParts[0].compareHtml = compareHtml;
    //       }
    //     });
    //   } else {
    //     source.activeParts.forEach((sp, indx) => {
    //       let compareSource = sp.text;
    //       this.activeDocs.forEach((i) => {
    //         let test = i.activeParts[indx];
    //         if (test) {
    //           let compareText = test.text;
    //           let compareHtml = this.runCompare(compareSource, compareText);
    //           test.compareHtml = compareHtml;
    //         }
    //       });
    //     });
    //   }
    //   this.docCompareItems = JSON.parse(JSON.stringify(this.docCompareItems));
    //   this.compareLoading = false;
    //   this.isComparing = true;
    //   this.compareFilter = false;
    // },
    // unPinItem(item) {
    //   item.pinned = false;
    //   // this.$nextTick(() => {
    //   //   this.refreshDocs();
    //   // });
    // },
    pinItem(item) {
      if (item.pinned) {
        item.pinned = false;
        return;
      }
      let existing = this.docCompareItems.find((x) => x.pinned);
      if (existing) {
        existing.pinned = false;
      }
      item.pinned = true;
      // this.$nextTick(() => {
      //   this.refreshDocs();
      // });
    },
    initDocItem(item) {
      let autoPin = this.items.some(x => x.doc_id === item.doc_id && x.pinned) ? true : false;

      return {
        ...item,
        pinned: autoPin,
        locked: false,
        lockedByPermission: !item.state.canEditDocParts || item.state.triggerDCAction !== null,
        visible: true,
        isUpdating: false,
        previousValue: null,
        created_date: moment(item.created_date).format("DD MMM YYYY"),
        commentsVisible: false,
      };
    },
    setupDocCompareData(data) {
      this.allCompareData = data;
      let docList = [];
      let docs = data;
      /*if(this.pinnedDoc){
        docs = docs.filter(x => x.doc_id !== this.pinnedDoc.doc_id);
      } */

      docList = docs.map((d, idx) => {
        let docItem = this.initDocItem(d.document);
        docItem.hover = false;
        docItem.position_order = idx;
        docItem.wordChecks = d.wordChecks;
        docItem.docHierarchies = d.docHierarchies;
        docItem.checkSummary = utils.documentCheckSummary(
          docItem,
          docItem.wordChecks,
          2
        );
        docItem.docContainerStyle = null;
        docItem.commentStyle = null;
        docItem.docHeaderStyle = null;
        return docItem;
      });

      this.docCompareItems = docList;
      this.compareLoading = false;
      this.showHierarchyFilter(false);
      this.loadParts();
      
      // this.setConsolidationMode();
    },
    async init(ids) {
      if (ids === undefined) {
        return;
      }

      // let languageOpts = nlpUtils.getLanguageTools(this.$loginState.user);
      // this.useSpellCheck = languageOpts.spellCheck.enabled;

      let list = ids.map(x => {
        let item = this.items.find(i => i.system_number === x);
        return {
          system_number: x,
          viewAction: item.viewAction
        }
      });

      let data = {
        ids: list,
        view: "full",
        partList: this.fullViewPartList
      }
      this.compareLoading = true;
      await this.getViewSetting();
      axios
        .post("document/docswithpartsList", data)
        .then((resp) => {
          this.allChecksData = resp.data.checks;
          let data = resp.data.documents.map((d) => {
            let checks = this.getAllChecks(d.tmpl_id);
            let setup = utils.setupDocument([d], checks, this.statuses);
            return {
              ...setup,
              wordChecks: checks,
            };
          });
          this.setupDocCompareData(data);
          this.changeSideBySideView();
          this.deriveColumnWidths();
          this.$nextTick(() => {
            const container = this.$refs.activeDocs;
            container.addEventListener('mousemove', this.handleResize);
            container.addEventListener('mouseup', this.stopResize);
          });
        })
        .catch((err) => {
          console.log(err);
          this.compareLoading = false;
        });
    },
    loadPartDetails() {
      let item = this.docCompareItems[0].parttypes.find(
        (x) => x.type === this.targetPart
      );
      if (item) {
        this.targetPartDetails = item;
      } else {
        this.targetPart = this.docCompareItems[0].parttypes[0].type;
        this.targetPartDetails = this.docCompareItems[0].parttypes[0];
      }
    },
    loadParts() {
    //   this.docPartFilter = false;
      this.loadPartDetails();
    //   this.selectedActiveParts = [];
    //   let parts = this.docCompareItems.map((x) =>
    //     x.parttypes.sort((a, b) => a.positionRow > b.positionRow ? 1 : -1)
    //       //.filter((x) => x.tmpl_part_metadata.tp_locked === 0)
    //       .map((p) => {
    //         return p.type;
    //       })
    //   );
    //   let array = [];
    //   parts.forEach((p) => {
    //     array = array.concat(p);
    //   });

    //   this.allParts = [...new Set(array)];
      this.fullDocParts = this.docCompareItems[0].parttypes.sort((a, b) => a.positionRow > b.positionRow ? 1 : -1);
      this.fullDocParts.forEach(p => {
        p.multiple = p.multi_row
      });

    //   if (this.targetPart === "") {
    //     this.targetPart = this.allParts[0];
    //   }

    //   let setData = this.docCompareItems.map((d) => {
    //     d.allSelected = false;
    //     d.activeParts = [];
    //     let newGroup = d.parttypes.find((p) => p.type === this.targetPart);
    //     if (newGroup) {
    //       let checks = this.getWordChecksForPart(
    //         this.targetPartDetails.tmpl_part_id,
    //         d.wordChecks,
    //         d.docHierarchies,
    //         d.tmpl_id
    //       );
    //       let newParts = newGroup.parts.map((x) => ({
    //         ...x,
    //         attributes:
    //           newGroup.tmpl_part_metadata.attributes.length > 0
    //             ? x.attributes.map((a) => {
    //                 let attrChecks = this.getWordChecksForPart(
    //                   this.targetPartDetails.tmpl_part_id,
    //                   d.wordChecks,
    //                   d.docHierarchies,
    //                   d.tmpl_id,
    //                   a
    //                 );
    //                 return {
    //                   ...a,
    //                   wordChecks: attrChecks,
    //                 };
    //               })
    //             : x.attributes,
    //         selected: false,
    //         wordChecks: checks,
    //         compareHtml: "",
    //         previousValue: x.text,
    //         tmpl_part_metadata: newGroup.tmpl_part_metadata,
    //         forceRefresh: false,
    //       }));
    //       d.activeParts = newParts.map((object) => ({ ...object }));
    //     }

    //     return d;
    //   });

    //   this.docCompareItems = setData;
    //   this.$nextTick(() => {
    //     this.refreshDocs();
    //   });
    },
    initCompare() {
      let ids = this.docCompareItems.map((x) => {
        return x.system_number;
      });

      if (ids.length > 0) {
        this.init(ids);
        this.deriveColumnWidths();
      }
    },
    changeView(val) {
      this.$emit("changeView", val);
    },
    close() {
      this.$emit("close");
    },
    reOrder(oldIndex, newIndex) {
      const oldDoc = this.activeDocs[oldIndex];
      const newDoc = this.activeDocs[newIndex];
      if (oldDoc.pinned || newDoc.pinned) return;
      oldDoc.hover = false;
      newDoc.hover = false;
      const oldItemIndex = this.docCompareItems.findIndex(x => x.doc_id === oldDoc.doc_id);
      const newItemIndex = this.docCompareItems.findIndex(x => x.doc_id === newDoc.doc_id);
      
      const newDocuments = [...this.docCompareItems];
      const movedItem = newDocuments[oldItemIndex];
      newDocuments.splice(oldItemIndex, 1);
      newDocuments.splice(newItemIndex, 0, movedItem);
      this.docCompareItems = newDocuments;     
    },
    removeDocument(index) {
      this.docCompareItems.splice(index, 1);
      this.deriveColumnWidths();
    },
    showComments(doc, visible) {
      doc.commentsVisible = visible;
      doc.current_doc_view.document.commentsVisible = visible;
      this.deriveColumnWidths();
    },
    startResize(event) {
      if (event.button !== 0) return;
      event.preventDefault();
      this.resizing = true;
      this.resizeStartX = event.clientX;
      this.resizeStartWidth = this.viewSetting.defaultColumnWidth;
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },
    handleResize(event) {
      if (!this.resizing) return;
      event.preventDefault();
      const deltaX = event.clientX - this.resizeStartX;
      const newWidth = Math.max(400, this.resizeStartWidth + deltaX); // Minimum width of 400px
      this.viewSetting.defaultColumnWidth = newWidth;
      this.deriveColumnWidths();
      this.saveViewSetting();
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    },
    deriveColumnWidths() {
      let docDetailWidth = this.viewSetting.defaultColumnWidth;
      let commentWidth = 400;
      const availableWidth = window.innerWidth - 300;
      const availableHeight = window.innerHeight - 320;
      this.maxHeight = `${availableHeight}px`;

      let usedWidth = this.docCompareItems.reduce(
        (p, c) => p + docDetailWidth + (c.commentsVisible ? commentWidth : 0), 0);

      if (usedWidth < availableWidth) {
        docDetailWidth = (docDetailWidth * availableWidth) / usedWidth;
        commentWidth = (commentWidth * availableWidth) / usedWidth;
      }

      this.docCompareItems.forEach((d, di) => {
        let width = docDetailWidth;
        if (d.commentsVisible) width += commentWidth;
        d.docContainerStyle = { minWidth: `${width}px`, maxWidth: `${width}px` };
        d.commentStyle = d.commentsVisible ? { minWidth: `${commentWidth - 10}px`, maxWidth: `${commentWidth - 10}px` } : null;
        width = docDetailWidth - (di === 0  ? 5 : 3); //allow for border
        if (d.file_id) width = docDetailWidth;
        d.docPartStyle = { minWidth: `${width}px`, maxWidth: `${width}px`, maxHeight: this.maxHeight };
        width = docDetailWidth - 20;
        d.docHeaderStyle = { minWidth: `${width}px`, maxWidth: `${width}px` };
      });
    },
    handleDragStart(event, index, doc) {
      if (doc.pinned) return;
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/html", event.target.innerHTML);
      // Add a subtle visual feedback
      event.target.style.opacity = "0.5";
    },
    handleDragEnd(event) {
      event.target.style.opacity = "1";
      this.draggedIndex = null;
      this.dragOverIndex = null;
    },
    handleDragOver(event, index, doc) {
      if (doc.pinned) return;
      if (this.draggedIndex === null || this.draggedIndex === index) return;
      this.dragOverIndex = index;
      event.dataTransfer.dropEffect = "move";
    },
    handleDragLeave() {
      this.dragOverIndex = null;
    },
    handleDrop(dropIndex, doc) {
      if (doc.pinned) return;
      if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
        this.dragOverIndex = null;
        return;
      }
      this.reOrder(this.draggedIndex, dropIndex);
      this.draggedIndex = null;
      this.dragOverIndex = null;
    },
    async getViewSetting() {
      let resp = await this.$loginState.getUserViewSetting(this.$options._componentTag);
      if (resp) {
        this.viewSetting = resp;
      }
    },
    async saveViewSetting() {
      let resp = await this.$loginState.saveUserViewSetting(this.$options._componentTag, this.viewSetting);
    },
  },
};
</script>

<style scoped lang="scss">
.docComparisonHolder {
  $pad-bottom: 5px;

  /** {
        font-family: 'Martel Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
    }  */

  .filterPanel {
    .v-expansion-panel-header {
      .v-expansion-panel-header__icon {
        margin-left: 50% !important;
      }
    }
  }

  del {
    text-decoration: line-through;
    color: #b30000;
    background: #f1a19a;
  }

  ins {
    text-decoration: underline;
    background: #59e700c7;
  }

  max-height: calc(100vh - 45px - #{$pad-bottom}) !important;
  overflow: hidden;
  height: calc(100vh - 45px - #{$pad-bottom}) !important;

  .v-card__title {
    height: 60px;
  }

  .v-card__text {
    max-height: calc(100vh - 60px) !important;
    height: calc(100vh - 60px) !important;
    //width: calc(100vw - 75px);
    //max-width: calc(100vw - 75px);
    background-color: #ffffff;
    overflow: hidden;
    padding-bottom: 0px !important;
    padding-right: 4px !important;
    padding-top: 3px !important;
    padding-left: 4px !important;
    overflow-x: hidden;

    $filter-height: 30px;
    $navHeight: 17px;

    .docComparisonFilterRowExpanded {
      height: 7px + $filter-height + $navHeight;
      //border: 1px solid #bbddfb;
      border-radius: 4px;
      font-family: "Martel Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #7d93b4;
      padding-top: 8px;
      padding-right: 30px;
      padding-left: 15px;

      .items {
        font-family: "Martel Sans";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #7d93b4;
        padding-top: 15px;

        .links {
          padding-left: 5px;
          font-family: "Martel Sans";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #377dff;
        }
      }

      .col {
        height: $filter-height;

        .comparePartsFilters {
          height: 55px;
          padding-top: 5px;
        }
        .comparePartsActions {
          height: 50px;
          padding: 0px 15px;

          .header {
            font-family: "Martel Sans";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 24px;
            color: #3e3e3e;
          }
        }

        .filterPanel {
          .v-expansion-panel-content {
            height: $filter-height;
          }
          .v-expansion-panel__header {
            min-height: $navHeight;
            height: $filter-height;
          }
        }
      }
    }

    .docComparisonFilterRow {
      border: 1px solid #bbddfb;
      border-radius: 4px;
      .row.col {
        .v-expansion-panels .v-expansion-panel {
          height: $filter-height + $navHeight;
        }
        .v-expansion-panel__header {
          min-height: $navHeight + $navHeight;
          height: $navHeight + $navHeight;
        }
      }
    }

    .docComparisonContent {
      height: calc(100% - 45px + #{$navHeight});
      max-height: calc(100% - 45px + #{$navHeight});
      .col {
        padding-top: 10px;
        height: 100%;
        max-height: 100%;
        padding-bottom: 0px;
      }
    }

    .docComparisonContentExpanded {
      height: calc(100vh - 65px - #{$filter-height} - #{$navHeight});
      max-height: calc(100vh - 65px - #{$filter-height} - #{$navHeight});
      margin-top: 0px;
      .col {
        padding-top: 10px;
        height: 100%;
        max-height: 100%;
        padding-bottom: 0px;
      }
    }
  }
}

.v-badge__badge {
  padding: 5px 4px !important;
}
.dialoge-select {
  font-size: 12px;
}
.dialoge-select > div.v-text-field__details {
  max-height: 0px;
  padding: 0;
  margin: 0;
}
.dialoge-select > div.v-messages {
  max-height: 0px;
  padding: 0;
  margin: 0;
}
.dialogue-nav-draw {
	left: 68px;
}

.move-handle {
  height: 25px;
  display: flex;
  width: 125px;
  margin-left: calc(100% - 160px);
  background-color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-top: solid 1px gray;
  border-left: solid 1px gray;
  border-right: solid 1px gray;
  // opacity: 0.3;
  transition: opacity 0.2s ease;
  margin-bottom: -2px;
  position: relative;

  .drag-handle {
    cursor: move;
  }

  // &:hover {
  //   opacity: 0.7;
  // }
}
.header-handle {
  cursor: move;
  transition: all 0.2s ease;

  &:hover {
    background-color: #eeeeee;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &.dragging {
    opacity: 0.5;
    border: 2px dashed #4caf50;
  }

  &.drag-over {
    border: 2px solid #4caf50;
    background-color: #e8f5e9;
    transform: scale(1.02);
  }
}
.resize-filler, .resize-handle {
  width: 5px;
  position: relative;
  flex-shrink: 0;
  display: flex;
  margin: 0px 10px 0px 5px;
}
.resize-handle {
  cursor: col-resize;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);

    .resize-handle-inner {
      background-color: #4CAF50;
      opacity: 1;
    }
  }

  &:active {
    background-color: rgba(76, 175, 80, 0.1);
  }
}

.resize-handle-inner {
  width: 3px;
  height: 40px;
  background-color: #ddd;
  border-radius: 2px;
  opacity: 0.5;
  transition: all 0.2s ease;
  pointer-events: none;
}
</style>